/**
 * Auto-generated Locale Data File for zh-TW.
 * This is generated in the @box/cldr-data project.
 * @IMPORTANT: DO NOT MODIFY THIS FILE DIRECTLY
 */

import type { NumberFormat, NumbersData, NameItem, LanguagesData, LocaleData, TimeZone, TimeZoneList, WeekData, WeekDayNameData, NameSet, WeekDayNames } from '../types';

const languages: LanguagesData = {
    id: 63,
    bcp47Tag: 'zh-TW',
    name: 'Chinese (Traditional)',
    localizedName: '繁體中文',
    localizedNameList: [
        {
            id: 49,
            name: '土耳其文',
        },
        {
            id: 68,
            name: '丹麥文',
        },
        {
            id: 69,
            name: '巴克摩挪威文',
        },
        {
            id: 19,
            name: '日文',
        },
        {
            id: 71,
            name: '印地文',
        },
        {
            id: 10,
            name: '西班牙文',
        },
        {
            id: 72,
            name: '西班牙文 (拉丁美洲)',
        },
        {
            id: 70,
            name: '孟加拉文',
        },
        {
            id: 21,
            name: '法文',
        },
        {
            id: 65,
            name: '法文 (加拿大)',
        },
        {
            id: 30,
            name: '波蘭文',
        },
        {
            id: 61,
            name: '芬蘭文',
        },
        {
            id: 8,
            name: '俄文',
        },
        {
            id: 4,
            name: '英文',
        },
        {
            id: 66,
            name: '英文 (加拿大)',
        },
        {
            id: 59,
            name: '英文 (英國)',
        },
        {
            id: 67,
            name: '英文 (澳洲)',
        },
        {
            id: 24,
            name: '荷蘭文',
        },
        {
            id: 57,
            name: '瑞典文',
        },
        {
            id: 16,
            name: '義大利文',
        },
        {
            id: 14,
            name: '葡萄牙文',
        },
        {
            id: 18,
            name: '德文',
        },
        {
            id: 63,
            name: '繁體中文',
        },
        {
            id: 55,
            name: '韓文',
        },
        {
            id: 6,
            name: '簡體中文',
        },
    ],
};

const numbers: NumbersData = {
    long: [
        {
            digits: 1,
            msg: '{count, number}',
        },
        {
            digits: 2,
            msg: '{count, number}',
        },
        {
            digits: 3,
            msg: '{count, number}',
        },
        {
            digits: 4,
            msg: '{count, number}',
        },
        {
            digits: 1,
            msg: '{count, number}萬',
        },
        {
            digits: 2,
            msg: '{count, number}萬',
        },
        {
            digits: 3,
            msg: '{count, number}萬',
        },
        {
            digits: 4,
            msg: '{count, number}萬',
        },
        {
            digits: 1,
            msg: '{count, number}億',
        },
        {
            digits: 2,
            msg: '{count, number}億',
        },
        {
            digits: 3,
            msg: '{count, number}億',
        },
        {
            digits: 4,
            msg: '{count, number}億',
        },
        {
            digits: 1,
            msg: '{count, number}兆',
        },
        {
            digits: 2,
            msg: '{count, number}兆',
        },
    ],
    short: [
        {
            digits: 1,
            msg: '{count, number}',
        },
        {
            digits: 2,
            msg: '{count, number}',
        },
        {
            digits: 3,
            msg: '{count, number}',
        },
        {
            digits: 4,
            msg: '{count, number}',
        },
        {
            digits: 1,
            msg: '{count, number}萬',
        },
        {
            digits: 2,
            msg: '{count, number}萬',
        },
        {
            digits: 3,
            msg: '{count, number}萬',
        },
        {
            digits: 4,
            msg: '{count, number}萬',
        },
        {
            digits: 1,
            msg: '{count, number}億',
        },
        {
            digits: 2,
            msg: '{count, number}億',
        },
        {
            digits: 3,
            msg: '{count, number}億',
        },
        {
            digits: 4,
            msg: '{count, number}億',
        },
        {
            digits: 1,
            msg: '{count, number}兆',
        },
        {
            digits: 2,
            msg: '{count, number}兆',
        },
    ],
};

const timezones: Array<TimeZone> = [
    {
        name: 'Pacific/Kiritimati',
        displayName: 'GMT+14:00 基里地馬地島 +14',
        nameLocalized: '基里地馬地島',
        abbreviationStandard: '+14',
        id: 500,
        enabled: true
    },
    {
        name: 'Etc/GMT-14',
        displayName: 'GMT+14:00 GMT-14 +14',
        nameLocalized: 'GMT-14',
        abbreviationStandard: '+14',
        id: 375
    },
    {
        name: 'Pacific/Tongatapu',
        displayName: 'GMT+13:00 東加塔布島 +13/+14',
        nameLocalized: '東加塔布島',
        abbreviationStandard: '+13/+14',
        id: 520,
        enabled: true
    },
    {
        name: 'Pacific/Fakaofo',
        displayName: 'GMT+13:00 法考福 +13',
        nameLocalized: '法考福',
        abbreviationStandard: '+13',
        id: 491
    },
    {
        name: 'Pacific/Apia',
        displayName: 'GMT+13:00 阿皮亞 +13/+14',
        nameLocalized: '阿皮亞',
        abbreviationStandard: '+13/+14',
        id: 485
    },
    {
        name: 'Etc/GMT-13',
        displayName: 'GMT+13:00 GMT-13 +13',
        nameLocalized: 'GMT-13',
        abbreviationStandard: '+13',
        id: 374
    },
    {
        name: 'Pacific/Chatham',
        displayName: 'GMT+12:45 查坦 +1245/+1345',
        nameLocalized: '查坦',
        abbreviationStandard: '+1245/+1345',
        abbreviationDaylight: '+1245/+1345',
        id: 487
    },
    {
        name: 'Pacific/Kwajalein',
        displayName: 'GMT+12:00 瓜加林島 +12',
        nameLocalized: '瓜加林島',
        abbreviationStandard: '+12',
        id: 502
    },
    {
        name: 'Pacific/Wallis',
        displayName: 'GMT+12:00 瓦利斯 +12',
        nameLocalized: '瓦利斯',
        abbreviationStandard: '+12',
        id: 523
    },
    {
        name: 'Asia/Anadyr',
        displayName: 'GMT+12:00 阿那底 +12',
        nameLocalized: '阿那底',
        abbreviationStandard: '+12',
        id: 216
    },
    {
        name: 'Pacific/Wake',
        displayName: 'GMT+12:00 威克 +12',
        nameLocalized: '威克',
        abbreviationStandard: '+12',
        id: 522
    },
    {
        name: 'Pacific/Majuro',
        displayName: 'GMT+12:00 馬朱諾 +12',
        nameLocalized: '馬朱諾',
        abbreviationStandard: '+12',
        id: 503
    },
    {
        name: 'Antarctica/McMurdo',
        displayName: 'GMT+12:00 麥克默多 NZST',
        nameLocalized: '麥克默多',
        abbreviationStandard: 'NZST',
        abbreviationDaylight: 'NZDT',
        id: 206
    },
    {
        name: 'Asia/Kamchatka',
        displayName: 'GMT+12:00 堪察加 +12',
        nameLocalized: '堪察加',
        abbreviationStandard: '+12',
        id: 249
    },
    {
        name: 'Pacific/Funafuti',
        displayName: 'GMT+12:00 富那富提 +12',
        nameLocalized: '富那富提',
        abbreviationStandard: '+12',
        id: 493
    },
    {
        name: 'Pacific/Fiji',
        displayName: 'GMT+12:00 斐濟 +12/+13',
        nameLocalized: '斐濟',
        abbreviationStandard: '+12/+13',
        id: 492,
        enabled: true
    },
    {
        name: 'Pacific/Tarawa',
        displayName: 'GMT+12:00 塔拉瓦 +12',
        nameLocalized: '塔拉瓦',
        abbreviationStandard: '+12',
        id: 519
    },
    {
        name: 'Pacific/Auckland',
        displayName: 'GMT+12:00 奧克蘭 NZST',
        nameLocalized: '奧克蘭',
        abbreviationStandard: 'NZST',
        abbreviationDaylight: 'NZDT',
        id: 486,
        enabled: true
    },
    {
        name: 'Pacific/Nauru',
        displayName: 'GMT+12:00 諾魯 +12',
        nameLocalized: '諾魯',
        abbreviationStandard: '+12',
        id: 506
    },
    {
        name: 'Kwajalein',
        displayName: 'GMT+12:00 Kwajalein +12',
        nameLocalized: 'Kwajalein',
        abbreviationStandard: '+12',
        id: 474
    },
    {
        name: 'NZ',
        displayName: 'GMT+12:00 NZ NZST',
        nameLocalized: 'NZ',
        abbreviationStandard: 'NZST',
        abbreviationDaylight: 'NZDT',
        id: 483
    },
    {
        name: 'Antarctica/South_Pole',
        displayName: 'GMT+12:00 South Pole NZST',
        nameLocalized: 'South Pole',
        abbreviationStandard: 'NZST',
        abbreviationDaylight: 'NZDT',
        id: 209
    },
    {
        name: 'Pacific/Guadalcanal',
        displayName: 'GMT+11:00 瓜達康納爾島 +11',
        nameLocalized: '瓜達康納爾島',
        abbreviationStandard: '+11',
        id: 496
    },
    {
        name: 'Pacific/Ponape',
        displayName: 'GMT+11:00 波納佩 +11',
        nameLocalized: '波納佩',
        abbreviationStandard: '+11',
        id: 513
    },
    {
        name: 'Pacific/Kosrae',
        displayName: 'GMT+11:00 科斯瑞 +11',
        nameLocalized: '科斯瑞',
        abbreviationStandard: '+11',
        id: 501
    },
    {
        name: 'Pacific/Efate',
        displayName: 'GMT+11:00 埃法特 +11/+12',
        nameLocalized: '埃法特',
        abbreviationStandard: '+11/+12',
        id: 489
    },
    {
        name: 'Asia/Sakhalin',
        displayName: 'GMT+11:00 庫頁島 +11',
        nameLocalized: '庫頁島',
        abbreviationStandard: '+11',
        id: 275
    },
    {
        name: 'Asia/Magadan',
        displayName: 'GMT+11:00 馬加丹 +11',
        nameLocalized: '馬加丹',
        abbreviationStandard: '+11',
        id: 259,
        enabled: true
    },
    {
        name: 'Pacific/Noumea',
        displayName: 'GMT+11:00 諾美亞 +11/+12',
        nameLocalized: '諾美亞',
        abbreviationStandard: '+11/+12',
        id: 509
    },
    {
        name: 'Pacific/Norfolk',
        displayName: 'GMT+11:00 諾福克 +11/+12',
        nameLocalized: '諾福克',
        abbreviationStandard: '+11/+12',
        abbreviationDaylight: '+11/+12',
        id: 508
    },
    {
        name: 'Australia/Lord_Howe',
        displayName: 'GMT+10:30 豪勳爵島 +1030/+11',
        nameLocalized: '豪勳爵島',
        abbreviationStandard: '+1030/+11',
        abbreviationDaylight: '+1030/+11',
        id: 320
    },
    {
        name: 'Australia/LHI',
        displayName: 'GMT+10:30 LHI +1030/+11',
        nameLocalized: 'LHI',
        abbreviationStandard: '+1030/+11',
        abbreviationDaylight: '+1030/+11',
        id: 318
    },
    {
        name: 'Australia/Brisbane',
        displayName: 'GMT+10:00 布利斯班 AEST',
        nameLocalized: '布利斯班',
        abbreviationStandard: 'AEST',
        id: 311,
        enabled: true
    },
    {
        name: 'Antarctica/DumontDUrville',
        displayName: 'GMT+10:00 杜蒙杜比爾 +10',
        nameLocalized: '杜蒙杜比爾',
        abbreviationStandard: '+10',
        id: 204
    },
    {
        name: 'Australia/Lindeman',
        displayName: 'GMT+10:00 林德曼 AEST',
        nameLocalized: '林德曼',
        abbreviationStandard: 'AEST',
        id: 319
    },
    {
        name: 'Asia/Vladivostok',
        displayName: 'GMT+10:00 海參崴 +10',
        nameLocalized: '海參崴',
        abbreviationStandard: '+10',
        id: 293,
        enabled: true
    },
    {
        name: 'Australia/Hobart',
        displayName: 'GMT+10:00 荷巴特 AEST',
        nameLocalized: '荷巴特',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 317,
        enabled: true
    },
    {
        name: 'Pacific/Port_Moresby',
        displayName: 'GMT+10:00 莫士比港 +10',
        nameLocalized: '莫士比港',
        abbreviationStandard: '+10',
        id: 514
    },
    {
        name: 'Australia/Sydney',
        displayName: 'GMT+10:00 雪梨 AEST',
        nameLocalized: '雪梨',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 327,
        enabled: true
    },
    {
        name: 'Pacific/Saipan',
        displayName: 'GMT+10:00 塞班 ChST',
        nameLocalized: '塞班',
        abbreviationStandard: 'ChST',
        id: 516
    },
    {
        name: 'Pacific/Truk',
        displayName: 'GMT+10:00 楚克 +10',
        nameLocalized: '楚克',
        abbreviationStandard: '+10',
        id: 521
    },
    {
        name: 'Australia/Melbourne',
        displayName: 'GMT+10:00 墨爾本 AEST',
        nameLocalized: '墨爾本',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 321
    },
    {
        name: 'Pacific/Guam',
        displayName: 'GMT+10:00 關島 ChST',
        nameLocalized: '關島',
        abbreviationStandard: 'ChST',
        id: 497,
        enabled: true
    },
    {
        name: 'Australia/ACT',
        displayName: 'GMT+10:00 ACT AEST',
        nameLocalized: 'ACT',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 309
    },
    {
        name: 'Australia/Canberra',
        displayName: 'GMT+10:00 Canberra AEST',
        nameLocalized: 'Canberra',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 313
    },
    {
        name: 'Australia/Currie',
        displayName: 'GMT+10:00 Currie AEST',
        nameLocalized: 'Currie',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 314
    },
    {
        name: 'Australia/NSW',
        displayName: 'GMT+10:00 NSW AEST',
        nameLocalized: 'NSW',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 323
    },
    {
        name: 'Australia/Queensland',
        displayName: 'GMT+10:00 Queensland AEST',
        nameLocalized: 'Queensland',
        abbreviationStandard: 'AEST',
        id: 325
    },
    {
        name: 'Australia/Tasmania',
        displayName: 'GMT+10:00 Tasmania AEST',
        nameLocalized: 'Tasmania',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 328
    },
    {
        name: 'Australia/Victoria',
        displayName: 'GMT+10:00 Victoria AEST',
        nameLocalized: 'Victoria',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 329
    },
    {
        name: 'Pacific/Yap',
        displayName: 'GMT+10:00 Yap +10',
        nameLocalized: 'Yap',
        abbreviationStandard: '+10',
        id: 524
    },
    {
        name: 'Australia/Broken_Hill',
        displayName: 'GMT+09:30 布羅肯希爾 ACST',
        nameLocalized: '布羅肯希爾',
        abbreviationStandard: 'ACST',
        abbreviationDaylight: 'ACDT',
        id: 312
    },
    {
        name: 'Australia/Adelaide',
        displayName: 'GMT+09:30 阿得雷德 ACST',
        nameLocalized: '阿得雷德',
        abbreviationStandard: 'ACST',
        abbreviationDaylight: 'ACDT',
        id: 310,
        enabled: true
    },
    {
        name: 'Australia/Darwin',
        displayName: 'GMT+09:30 達爾文 ACST',
        nameLocalized: '達爾文',
        abbreviationStandard: 'ACST',
        id: 315,
        enabled: true
    },
    {
        name: 'Australia/North',
        displayName: 'GMT+09:30 North ACST',
        nameLocalized: 'North',
        abbreviationStandard: 'ACST',
        id: 322
    },
    {
        name: 'Australia/South',
        displayName: 'GMT+09:30 South ACST',
        nameLocalized: 'South',
        abbreviationStandard: 'ACST',
        abbreviationDaylight: 'ACDT',
        id: 326
    },
    {
        name: 'Australia/Yancowinna',
        displayName: 'GMT+09:30 Yancowinna ACST',
        nameLocalized: 'Yancowinna',
        abbreviationStandard: 'ACST',
        abbreviationDaylight: 'ACDT',
        id: 331
    },
    {
        name: 'Asia/Jayapura',
        displayName: 'GMT+09:00 加亞布拉 WIT',
        nameLocalized: '加亞布拉',
        abbreviationStandard: 'WIT',
        id: 246
    },
    {
        name: 'Asia/Pyongyang',
        displayName: 'GMT+09:00 平壤 KST',
        nameLocalized: '平壤',
        abbreviationStandard: 'KST',
        id: 269
    },
    {
        name: 'Pacific/Palau',
        displayName: 'GMT+09:00 帛琉 +09',
        nameLocalized: '帛琉',
        abbreviationStandard: '+09',
        id: 511
    },
    {
        name: 'Asia/Tokyo',
        displayName: 'GMT+09:00 東京 JST',
        nameLocalized: '東京',
        abbreviationStandard: 'JST',
        id: 287,
        enabled: true
    },
    {
        name: 'Asia/Dili',
        displayName: 'GMT+09:00 帝力 +09',
        nameLocalized: '帝力',
        abbreviationStandard: '+09',
        id: 236
    },
    {
        name: 'Asia/Seoul',
        displayName: 'GMT+09:00 首爾 KST',
        nameLocalized: '首爾',
        abbreviationStandard: 'KST',
        id: 277,
        enabled: true
    },
    {
        name: 'Asia/Yakutsk',
        displayName: 'GMT+09:00 雅庫次克 +09',
        nameLocalized: '雅庫次克',
        abbreviationStandard: '+09',
        id: 294,
        enabled: true
    },
    {
        name: 'Australia/Eucla',
        displayName: 'GMT+08:45 尤克拉 +0845/+0945',
        nameLocalized: '尤克拉',
        abbreviationStandard: '+0845/+0945',
        id: 316
    },
    {
        name: 'Asia/Shanghai',
        displayName: 'GMT+08:00 上海 CST',
        nameLocalized: '上海',
        abbreviationStandard: 'CST',
        id: 278,
        enabled: true
    },
    {
        name: 'Asia/Kuching',
        displayName: 'GMT+08:00 古晉 +08',
        nameLocalized: '古晉',
        abbreviationStandard: '+08',
        id: 255
    },
    {
        name: 'Asia/Taipei',
        displayName: 'GMT+08:00 台北 CST',
        nameLocalized: '台北',
        abbreviationStandard: 'CST',
        id: 280,
        enabled: true
    },
    {
        name: 'Asia/Irkutsk',
        displayName: 'GMT+08:00 伊爾庫次克 +08',
        nameLocalized: '伊爾庫次克',
        abbreviationStandard: '+08',
        id: 243
    },
    {
        name: 'Asia/Kuala_Lumpur',
        displayName: 'GMT+08:00 吉隆坡 +08',
        nameLocalized: '吉隆坡',
        abbreviationStandard: '+08',
        id: 254,
        enabled: true
    },
    {
        name: 'Australia/Perth',
        displayName: 'GMT+08:00 伯斯 AWST',
        nameLocalized: '伯斯',
        abbreviationStandard: 'AWST',
        id: 324,
        enabled: true
    },
    {
        name: 'Asia/Brunei',
        displayName: 'GMT+08:00 汶萊 +08',
        nameLocalized: '汶萊',
        abbreviationStandard: '+08',
        id: 227
    },
    {
        name: 'Asia/Hong_Kong',
        displayName: 'GMT+08:00 香港 HKST',
        nameLocalized: '香港',
        abbreviationStandard: 'HKST',
        id: 241,
        enabled: true
    },
    {
        name: 'Asia/Ulaanbaatar',
        displayName: 'GMT+08:00 烏蘭巴托 +08/+09',
        nameLocalized: '烏蘭巴托',
        abbreviationStandard: '+08/+09',
        id: 289,
        enabled: true
    },
    {
        name: 'Asia/Makassar',
        displayName: 'GMT+08:00 馬卡沙爾 WITA',
        nameLocalized: '馬卡沙爾',
        abbreviationStandard: 'WITA',
        id: 260
    },
    {
        name: 'Asia/Manila',
        displayName: 'GMT+08:00 馬尼拉 PST',
        nameLocalized: '馬尼拉',
        abbreviationStandard: 'PST',
        id: 261
    },
    {
        name: 'Antarctica/Casey',
        displayName: 'GMT+08:00 凱西 +08',
        nameLocalized: '凱西',
        abbreviationStandard: '+08',
        id: 202
    },
    {
        name: 'Asia/Choibalsan',
        displayName: 'GMT+08:00 喬巴山 +08/+09',
        nameLocalized: '喬巴山',
        abbreviationStandard: '+08/+09',
        id: 229
    },
    {
        name: 'Asia/Singapore',
        displayName: 'GMT+08:00 新加坡 +08',
        nameLocalized: '新加坡',
        abbreviationStandard: '+08',
        id: 279
    },
    {
        name: 'Asia/Macau',
        displayName: 'GMT+08:00 澳門 CST',
        nameLocalized: '澳門',
        abbreviationStandard: 'CST',
        id: 258
    },
    {
        name: 'Asia/Chongqing',
        displayName: 'GMT+08:00 Chongqing CST',
        nameLocalized: 'Chongqing',
        abbreviationStandard: 'CST',
        id: 230
    },
    {
        name: 'Asia/Chungking',
        displayName: 'GMT+08:00 Chungking CST',
        nameLocalized: 'Chungking',
        abbreviationStandard: 'CST',
        id: 231
    },
    {
        name: 'Asia/Harbin',
        displayName: 'GMT+08:00 Harbin CST',
        nameLocalized: 'Harbin',
        abbreviationStandard: 'CST',
        id: 240
    },
    {
        name: 'Asia/Kashgar',
        displayName: 'GMT+08:00 Kashgar CST',
        nameLocalized: 'Kashgar',
        abbreviationStandard: 'CST',
        id: 251
    },
    {
        name: 'Asia/Ulan_Bator',
        displayName: 'GMT+08:00 Ulan Bator +08/+09',
        nameLocalized: 'Ulan Bator',
        abbreviationStandard: '+08/+09',
        id: 290
    },
    {
        name: 'Asia/Vientiane',
        displayName: 'GMT+07:00 永珍 +07',
        nameLocalized: '永珍',
        abbreviationStandard: '+07',
        id: 292
    },
    {
        name: 'Asia/Krasnoyarsk',
        displayName: 'GMT+07:00 克拉斯諾亞爾斯克 +07',
        nameLocalized: '克拉斯諾亞爾斯克',
        abbreviationStandard: '+07',
        id: 253,
        enabled: true
    },
    {
        name: 'Asia/Pontianak',
        displayName: 'GMT+07:00 坤甸 WIB',
        nameLocalized: '坤甸',
        abbreviationStandard: 'WIB',
        id: 268
    },
    {
        name: 'Asia/Phnom_Penh',
        displayName: 'GMT+07:00 金邊 +07',
        nameLocalized: '金邊',
        abbreviationStandard: '+07',
        id: 267
    },
    {
        name: 'Asia/Hovd',
        displayName: 'GMT+07:00 科布多 +07/+08',
        nameLocalized: '科布多',
        abbreviationStandard: '+07/+08',
        id: 242
    },
    {
        name: 'Asia/Saigon',
        displayName: 'GMT+07:00 胡志明市 +07',
        nameLocalized: '胡志明市',
        abbreviationStandard: '+07',
        id: 274
    },
    {
        name: 'Asia/Bangkok',
        displayName: 'GMT+07:00 曼谷 +07',
        nameLocalized: '曼谷',
        abbreviationStandard: '+07',
        id: 224,
        enabled: true
    },
    {
        name: 'Asia/Jakarta',
        displayName: 'GMT+07:00 雅加達 WIB',
        nameLocalized: '雅加達',
        abbreviationStandard: 'WIB',
        id: 245
    },
    {
        name: 'Asia/Novosibirsk',
        displayName: 'GMT+07:00 新西伯利亞 +07',
        nameLocalized: '新西伯利亞',
        abbreviationStandard: '+07',
        id: 264
    },
    {
        name: 'Indian/Christmas',
        displayName: 'GMT+07:00 聖誕島 +07',
        nameLocalized: '聖誕島',
        abbreviationStandard: '+07',
        id: 461
    },
    {
        name: 'Antarctica/Davis',
        displayName: 'GMT+07:00 戴維斯 +07',
        nameLocalized: '戴維斯',
        abbreviationStandard: '+07',
        id: 203
    },
    {
        name: 'Indian/Cocos',
        displayName: 'GMT+06:30 科科斯群島 +0630',
        nameLocalized: '科科斯群島',
        abbreviationStandard: '+0630',
        id: 462
    },
    {
        name: 'Asia/Bishkek',
        displayName: 'GMT+06:00 比什凱克 +06',
        nameLocalized: '比什凱克',
        abbreviationStandard: '+06',
        id: 226
    },
    {
        name: 'Asia/Thimphu',
        displayName: 'GMT+06:00 廷布 +06',
        nameLocalized: '廷布',
        abbreviationStandard: '+06',
        id: 286
    },
    {
        name: 'Indian/Chagos',
        displayName: 'GMT+06:00 查戈斯 +06',
        nameLocalized: '查戈斯',
        abbreviationStandard: '+06',
        id: 460
    },
    {
        name: 'Asia/Urumqi',
        displayName: 'GMT+06:00 烏魯木齊 +06',
        nameLocalized: '烏魯木齊',
        abbreviationStandard: '+06',
        id: 291
    },
    {
        name: 'Asia/Omsk',
        displayName: 'GMT+06:00 鄂木斯克 +06',
        nameLocalized: '鄂木斯克',
        abbreviationStandard: '+06',
        id: 265
    },
    {
        name: 'Asia/Dhaka',
        displayName: 'GMT+06:00 達卡 +06/+07',
        nameLocalized: '達卡',
        abbreviationStandard: '+06/+07',
        id: 235,
        enabled: true
    },
    {
        name: 'Asia/Colombo',
        displayName: 'GMT+05:30 可倫坡 +0530',
        nameLocalized: '可倫坡',
        abbreviationStandard: '+0530',
        id: 232,
        enabled: true
    },
    {
        name: 'Asia/Qyzylorda',
        displayName: 'GMT+05:00 克孜勒奧爾達 +05',
        nameLocalized: '克孜勒奧爾達',
        abbreviationStandard: '+05',
        id: 271
    },
    {
        name: 'Asia/Dushanbe',
        displayName: 'GMT+05:00 杜桑貝 +05',
        nameLocalized: '杜桑貝',
        abbreviationStandard: '+05',
        id: 238
    },
    {
        name: 'Antarctica/Vostok',
        displayName: 'GMT+05:00 沃斯托克 +05',
        nameLocalized: '沃斯托克',
        abbreviationStandard: '+05',
        id: 211
    },
    {
        name: 'Asia/Ashgabat',
        displayName: 'GMT+05:00 阿什哈巴特 +05',
        nameLocalized: '阿什哈巴特',
        abbreviationStandard: '+05',
        id: 219
    },
    {
        name: 'Asia/Aqtobe',
        displayName: 'GMT+05:00 阿克托比 +05',
        nameLocalized: '阿克托比',
        abbreviationStandard: '+05',
        id: 218
    },
    {
        name: 'Asia/Aqtau',
        displayName: 'GMT+05:00 阿克套 +05',
        nameLocalized: '阿克套',
        abbreviationStandard: '+05',
        id: 217
    },
    {
        name: 'Asia/Almaty',
        displayName: 'GMT+05:00 阿拉木圖 +05',
        nameLocalized: '阿拉木圖',
        abbreviationStandard: '+05',
        id: 214,
        enabled: true
    },
    {
        name: 'Asia/Oral',
        displayName: 'GMT+05:00 烏拉爾 +05',
        nameLocalized: '烏拉爾',
        abbreviationStandard: '+05',
        id: 266
    },
    {
        name: 'Indian/Maldives',
        displayName: 'GMT+05:00 馬爾地夫 +05',
        nameLocalized: '馬爾地夫',
        abbreviationStandard: '+05',
        id: 466
    },
    {
        name: 'Antarctica/Mawson',
        displayName: 'GMT+05:00 莫森 +05',
        nameLocalized: '莫森',
        abbreviationStandard: '+05',
        id: 205
    },
    {
        name: 'Indian/Kerguelen',
        displayName: 'GMT+05:00 凱爾蓋朗島 +05',
        nameLocalized: '凱爾蓋朗島',
        abbreviationStandard: '+05',
        id: 464
    },
    {
        name: 'Asia/Karachi',
        displayName: 'GMT+05:00 喀拉蚩 PKST',
        nameLocalized: '喀拉蚩',
        abbreviationStandard: 'PKST',
        id: 250,
        enabled: true
    },
    {
        name: 'Asia/Tashkent',
        displayName: 'GMT+05:00 塔什干 +05',
        nameLocalized: '塔什干',
        abbreviationStandard: '+05',
        id: 281
    },
    {
        name: 'Asia/Yekaterinburg',
        displayName: 'GMT+05:00 葉卡捷林堡 +05',
        nameLocalized: '葉卡捷林堡',
        abbreviationStandard: '+05',
        id: 295,
        enabled: true
    },
    {
        name: 'Asia/Samarkand',
        displayName: 'GMT+05:00 撒馬爾罕 +05',
        nameLocalized: '撒馬爾罕',
        abbreviationStandard: '+05',
        id: 276
    },
    {
        name: 'Asia/Kabul',
        displayName: 'GMT+04:30 喀布爾 +0430',
        nameLocalized: '喀布爾',
        abbreviationStandard: '+0430',
        id: 248,
        enabled: true
    },
    {
        name: 'Asia/Baku',
        displayName: 'GMT+04:00 巴庫 +04/+05',
        nameLocalized: '巴庫',
        abbreviationStandard: '+04/+05',
        id: 223,
        enabled: true
    },
    {
        name: 'Asia/Dubai',
        displayName: 'GMT+04:00 杜拜 +04',
        nameLocalized: '杜拜',
        abbreviationStandard: '+04',
        id: 237
    },
    {
        name: 'Europe/Samara',
        displayName: 'GMT+04:00 沙馬拉 +04',
        nameLocalized: '沙馬拉',
        abbreviationStandard: '+04',
        id: 428
    },
    {
        name: 'Indian/Reunion',
        displayName: 'GMT+04:00 留尼旺島 +04',
        nameLocalized: '留尼旺島',
        abbreviationStandard: '+04',
        id: 469
    },
    {
        name: 'Indian/Mahe',
        displayName: 'GMT+04:00 馬埃島 +04',
        nameLocalized: '馬埃島',
        abbreviationStandard: '+04',
        id: 465
    },
    {
        name: 'Asia/Muscat',
        displayName: 'GMT+04:00 馬斯開特 +04',
        nameLocalized: '馬斯開特',
        abbreviationStandard: '+04',
        id: 262,
        enabled: true
    },
    {
        name: 'Asia/Tbilisi',
        displayName: 'GMT+04:00 第比利斯 +04',
        nameLocalized: '第比利斯',
        abbreviationStandard: '+04',
        id: 282,
        enabled: true
    },
    {
        name: 'Asia/Yerevan',
        displayName: 'GMT+04:00 葉里溫 +04/+05',
        nameLocalized: '葉里溫',
        abbreviationStandard: '+04/+05',
        id: 296,
        enabled: true
    },
    {
        name: 'Indian/Mauritius',
        displayName: 'GMT+04:00 模里西斯 +04/+05',
        nameLocalized: '模里西斯',
        abbreviationStandard: '+04/+05',
        id: 467
    },
    {
        name: 'Asia/Tehran',
        displayName: 'GMT+03:30 德黑蘭 +0330/+0430',
        nameLocalized: '德黑蘭',
        abbreviationStandard: '+0330/+0430',
        id: 283,
        enabled: true
    },
    {
        name: 'Asia/Damascus',
        displayName: 'GMT+03:00 大馬士革 +03',
        nameLocalized: '大馬士革',
        abbreviationStandard: '+03',
        id: 234
    },
    {
        name: 'Asia/Bahrain',
        displayName: 'GMT+03:00 巴林 +03',
        nameLocalized: '巴林',
        abbreviationStandard: '+03',
        id: 222
    },
    {
        name: 'Asia/Baghdad',
        displayName: 'GMT+03:00 巴格達 +03/+04',
        nameLocalized: '巴格達',
        abbreviationStandard: '+03/+04',
        id: 221,
        enabled: true
    },
    {
        name: 'Asia/Qatar',
        displayName: 'GMT+03:00 卡達 +03',
        nameLocalized: '卡達',
        abbreviationStandard: '+03',
        id: 270
    },
    {
        name: 'Europe/Istanbul',
        displayName: 'GMT+03:00 伊斯坦堡 +03',
        nameLocalized: '伊斯坦堡',
        abbreviationStandard: '+03',
        id: 244,
        enabled: true
    },
    {
        name: 'Europe/Volgograd',
        displayName: 'GMT+03:00 伏爾加格勒 MSK',
        nameLocalized: '伏爾加格勒',
        abbreviationStandard: 'MSK',
        id: 443
    },
    {
        name: 'Africa/Djibouti',
        displayName: 'GMT+03:00 吉布地 EAT',
        nameLocalized: '吉布地',
        abbreviationStandard: 'EAT',
        id: 20
    },
    {
        name: 'Asia/Amman',
        displayName: 'GMT+03:00 安曼 +03',
        nameLocalized: '安曼',
        abbreviationStandard: '+03',
        id: 215,
        enabled: true
    },
    {
        name: 'Indian/Antananarivo',
        displayName: 'GMT+03:00 安塔那那利弗 EAT',
        nameLocalized: '安塔那那利弗',
        abbreviationStandard: 'EAT',
        id: 459
    },
    {
        name: 'Asia/Riyadh',
        displayName: 'GMT+03:00 利雅德 +03',
        nameLocalized: '利雅德',
        abbreviationStandard: '+03',
        id: 273
    },
    {
        name: 'Africa/Kampala',
        displayName: 'GMT+03:00 坎帕拉 EAT',
        nameLocalized: '坎帕拉',
        abbreviationStandard: 'EAT',
        id: 27
    },
    {
        name: 'Africa/Dar_es_Salaam',
        displayName: 'GMT+03:00 沙蘭港 EAT',
        nameLocalized: '沙蘭港',
        abbreviationStandard: 'EAT',
        id: 19
    },
    {
        name: 'Europe/Simferopol',
        displayName: 'GMT+03:00 辛非洛浦 MSK',
        nameLocalized: '辛非洛浦',
        abbreviationStandard: 'MSK',
        id: 431
    },
    {
        name: 'Asia/Aden',
        displayName: 'GMT+03:00 亞丁 +03',
        nameLocalized: '亞丁',
        abbreviationStandard: '+03',
        id: 213
    },
    {
        name: 'Africa/Nairobi',
        displayName: 'GMT+03:00 奈洛比 EAT',
        nameLocalized: '奈洛比',
        abbreviationStandard: 'EAT',
        id: 43,
        enabled: true
    },
    {
        name: 'Europe/Minsk',
        displayName: 'GMT+03:00 明斯克 +03',
        nameLocalized: '明斯克',
        abbreviationStandard: '+03',
        id: 418,
        enabled: true
    },
    {
        name: 'Africa/Addis_Ababa',
        displayName: 'GMT+03:00 阿迪斯阿貝巴 EAT',
        nameLocalized: '阿迪斯阿貝巴',
        abbreviationStandard: 'EAT',
        id: 3
    },
    {
        name: 'Africa/Asmera',
        displayName: 'GMT+03:00 阿斯瑪拉 EAT',
        nameLocalized: '阿斯瑪拉',
        abbreviationStandard: 'EAT',
        id: 6
    },
    {
        name: 'Antarctica/Syowa',
        displayName: 'GMT+03:00 昭和基地 +03',
        nameLocalized: '昭和基地',
        abbreviationStandard: '+03',
        id: 210
    },
    {
        name: 'Asia/Kuwait',
        displayName: 'GMT+03:00 科威特 +03',
        nameLocalized: '科威特',
        abbreviationStandard: '+03',
        id: 256,
        enabled: true
    },
    {
        name: 'Indian/Comoro',
        displayName: 'GMT+03:00 科摩羅群島 EAT',
        nameLocalized: '科摩羅群島',
        abbreviationStandard: 'EAT',
        id: 463
    },
    {
        name: 'Indian/Mayotte',
        displayName: 'GMT+03:00 馬約特島 EAT',
        nameLocalized: '馬約特島',
        abbreviationStandard: 'EAT',
        id: 468
    },
    {
        name: 'Europe/Moscow',
        displayName: 'GMT+03:00 莫斯科 MSK',
        nameLocalized: '莫斯科',
        abbreviationStandard: 'MSK',
        id: 420,
        enabled: true
    },
    {
        name: 'Africa/Mogadishu',
        displayName: 'GMT+03:00 摩加迪休 EAT',
        nameLocalized: '摩加迪休',
        abbreviationStandard: 'EAT',
        id: 41
    },
    {
        name: 'Africa/Asmara',
        displayName: 'GMT+03:00 Asmara EAT',
        nameLocalized: 'Asmara',
        abbreviationStandard: 'EAT',
        id: 5
    },
    {
        name: 'Asia/Istanbul',
        displayName: 'GMT+03:00 Istanbul +03',
        nameLocalized: 'Istanbul',
        abbreviationStandard: '+03',
        id: 407
    },
    {
        name: 'Europe/Tiraspol',
        displayName: 'GMT+03:00 Tiraspol MSK/MSD',
        nameLocalized: 'Tiraspol',
        abbreviationStandard: 'MSK/MSD',
        id: 437
    },
    {
        name: 'Europe/Kaliningrad',
        displayName: 'GMT+02:00 加里寧格勒 EET',
        nameLocalized: '加里寧格勒',
        abbreviationStandard: 'EET',
        id: 409
    },
    {
        name: 'Asia/Gaza',
        displayName: 'GMT+02:00 加薩 EET',
        nameLocalized: '加薩',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 239
    },
    {
        name: 'Asia/Nicosia',
        displayName: 'GMT+02:00 尼古西亞 EET',
        nameLocalized: '尼古西亞',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 263
    },
    {
        name: 'Europe/Bucharest',
        displayName: 'GMT+02:00 布加勒斯特 EET',
        nameLocalized: '布加勒斯特',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 398
    },
    {
        name: 'Africa/Bujumbura',
        displayName: 'GMT+02:00 布松布拉 CAT',
        nameLocalized: '布松布拉',
        abbreviationStandard: 'CAT',
        id: 13
    },
    {
        name: 'Africa/Blantyre',
        displayName: 'GMT+02:00 布蘭太爾 CAT',
        nameLocalized: '布蘭太爾',
        abbreviationStandard: 'CAT',
        id: 11
    },
    {
        name: 'Asia/Beirut',
        displayName: 'GMT+02:00 貝魯特 EET',
        nameLocalized: '貝魯特',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 225,
        enabled: true
    },
    {
        name: 'Europe/Riga',
        displayName: 'GMT+02:00 里加 EET',
        nameLocalized: '里加',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 426
    },
    {
        name: 'Africa/Tripoli',
        displayName: 'GMT+02:00 的黎波里 EET',
        nameLocalized: '的黎波里',
        abbreviationStandard: 'EET',
        id: 51
    },
    {
        name: 'Africa/Harare',
        displayName: 'GMT+02:00 哈拉雷 CAT',
        nameLocalized: '哈拉雷',
        abbreviationStandard: 'CAT',
        id: 25,
        enabled: true
    },
    {
        name: 'Africa/Johannesburg',
        displayName: 'GMT+02:00 約翰尼斯堡 SAST',
        nameLocalized: '約翰尼斯堡',
        abbreviationStandard: 'SAST',
        id: 26
    },
    {
        name: 'Asia/Jerusalem',
        displayName: 'GMT+02:00 耶路撒冷 IST',
        nameLocalized: '耶路撒冷',
        abbreviationStandard: 'IST',
        abbreviationDaylight: 'IDT',
        id: 247,
        enabled: true
    },
    {
        name: 'Europe/Sofia',
        displayName: 'GMT+02:00 索菲亞 EET',
        nameLocalized: '索菲亞',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 433
    },
    {
        name: 'Africa/Maputo',
        displayName: 'GMT+02:00 馬普托 CAT',
        nameLocalized: '馬普托',
        abbreviationStandard: 'CAT',
        id: 38
    },
    {
        name: 'Africa/Maseru',
        displayName: 'GMT+02:00 馬賽魯 SAST',
        nameLocalized: '馬賽魯',
        abbreviationStandard: 'SAST',
        id: 39
    },
    {
        name: 'Africa/Kigali',
        displayName: 'GMT+02:00 基加利 CAT',
        nameLocalized: '基加利',
        abbreviationStandard: 'CAT',
        id: 29
    },
    {
        name: 'Europe/Chisinau',
        displayName: 'GMT+02:00 基西紐 EET',
        nameLocalized: '基西紐',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 400
    },
    {
        name: 'Europe/Kiev',
        displayName: 'GMT+02:00 基輔 EET',
        nameLocalized: '基輔',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 410
    },
    {
        name: 'Africa/Khartoum',
        displayName: 'GMT+02:00 喀土穆 CAT',
        nameLocalized: '喀土穆',
        abbreviationStandard: 'CAT',
        id: 28
    },
    {
        name: 'Africa/Cairo',
        displayName: 'GMT+02:00 開羅 EET',
        nameLocalized: '開羅',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 14,
        enabled: true
    },
    {
        name: 'Europe/Athens',
        displayName: 'GMT+02:00 雅典 EET',
        nameLocalized: '雅典',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 392
    },
    {
        name: 'Europe/Tallinn',
        displayName: 'GMT+02:00 塔林 EET',
        nameLocalized: '塔林',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 435
    },
    {
        name: 'Africa/Windhoek',
        displayName: 'GMT+02:00 溫得和克 WAT',
        nameLocalized: '溫得和克',
        abbreviationStandard: 'WAT',
        id: 53,
        enabled: true
    },
    {
        name: 'Africa/Lusaka',
        displayName: 'GMT+02:00 路沙卡 CAT',
        nameLocalized: '路沙卡',
        abbreviationStandard: 'CAT',
        id: 36
    },
    {
        name: 'Africa/Gaborone',
        displayName: 'GMT+02:00 嘉柏隆里 CAT',
        nameLocalized: '嘉柏隆里',
        abbreviationStandard: 'CAT',
        id: 24
    },
    {
        name: 'Europe/Mariehamn',
        displayName: 'GMT+02:00 瑪麗港 EET',
        nameLocalized: '瑪麗港',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 417
    },
    {
        name: 'Europe/Vilnius',
        displayName: 'GMT+02:00 維爾紐斯 EET',
        nameLocalized: '維爾紐斯',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 442
    },
    {
        name: 'Europe/Helsinki',
        displayName: 'GMT+02:00 赫爾辛基 EET',
        nameLocalized: '赫爾辛基',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 405,
        enabled: true
    },
    {
        name: 'Africa/Mbabane',
        displayName: 'GMT+02:00 墨巴本 SAST',
        nameLocalized: '墨巴本',
        abbreviationStandard: 'SAST',
        id: 40
    },
    {
        name: 'Africa/Lubumbashi',
        displayName: 'GMT+02:00 盧本巴希 CAT',
        nameLocalized: '盧本巴希',
        abbreviationStandard: 'CAT',
        id: 35
    },
    {
        name: 'EET',
        displayName: 'GMT+02:00 EET EET',
        nameLocalized: 'EET',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 350
    },
    {
        name: 'Europe/Nicosia',
        displayName: 'GMT+02:00 Nicosia EET',
        nameLocalized: 'Nicosia',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 421
    },
    {
        name: 'Asia/Tel_Aviv',
        displayName: 'GMT+02:00 Tel Aviv IST',
        nameLocalized: 'Tel Aviv',
        abbreviationStandard: 'IST',
        abbreviationDaylight: 'IDT',
        id: 284
    },
    {
        name: 'Europe/Uzhgorod',
        displayName: 'GMT+02:00 Uzhgorod EET',
        nameLocalized: 'Uzhgorod',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 438
    },
    {
        name: 'Europe/Zaporozhye',
        displayName: 'GMT+02:00 Zaporozhye EET',
        nameLocalized: 'Zaporozhye',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 446
    },
    {
        name: 'Europe/Paris',
        displayName: 'GMT+01:00 巴黎 CET',
        nameLocalized: '巴黎',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 423
    },
    {
        name: 'Africa/Casablanca',
        displayName: 'GMT+01:00 卡薩布蘭卡 +01/+00',
        nameLocalized: '卡薩布蘭卡',
        abbreviationStandard: '+01/+00',
        id: 15,
        enabled: true
    },
    {
        name: 'Europe/Skopje',
        displayName: 'GMT+01:00 史高比耶 CET',
        nameLocalized: '史高比耶',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 432
    },
    {
        name: 'Africa/Niamey',
        displayName: 'GMT+01:00 尼亞美 WAT',
        nameLocalized: '尼亞美',
        abbreviationStandard: 'WAT',
        id: 45
    },
    {
        name: 'Africa/Brazzaville',
        displayName: 'GMT+01:00 布拉柴維爾 WAT',
        nameLocalized: '布拉柴維爾',
        abbreviationStandard: 'WAT',
        id: 12
    },
    {
        name: 'Europe/Prague',
        displayName: 'GMT+01:00 布拉格 CET',
        nameLocalized: '布拉格',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 425
    },
    {
        name: 'Europe/Bratislava',
        displayName: 'GMT+01:00 布拉提斯拉瓦 CET',
        nameLocalized: '布拉提斯拉瓦',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 396
    },
    {
        name: 'Europe/Budapest',
        displayName: 'GMT+01:00 布達佩斯 CET',
        nameLocalized: '布達佩斯',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 399,
        enabled: true
    },
    {
        name: 'Europe/Brussels',
        displayName: 'GMT+01:00 布魯塞爾 CET',
        nameLocalized: '布魯塞爾',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 397
    },
    {
        name: 'Europe/Zagreb',
        displayName: 'GMT+01:00 札格瑞布 CET',
        nameLocalized: '札格瑞布',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 445
    },
    {
        name: 'Europe/Vaduz',
        displayName: 'GMT+01:00 瓦都茲 CET',
        nameLocalized: '瓦都茲',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 439
    },
    {
        name: 'Africa/Ceuta',
        displayName: 'GMT+01:00 休達 CET',
        nameLocalized: '休達',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 16
    },
    {
        name: 'Europe/Tirane',
        displayName: 'GMT+01:00 地拉那 CET',
        nameLocalized: '地拉那',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 436
    },
    {
        name: 'Europe/Andorra',
        displayName: 'GMT+01:00 安道爾 CET',
        nameLocalized: '安道爾',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 391
    },
    {
        name: 'Africa/Libreville',
        displayName: 'GMT+01:00 自由市 WAT',
        nameLocalized: '自由市',
        abbreviationStandard: 'WAT',
        id: 32
    },
    {
        name: 'Africa/Douala',
        displayName: 'GMT+01:00 杜阿拉 WAT',
        nameLocalized: '杜阿拉',
        abbreviationStandard: 'WAT',
        id: 21
    },
    {
        name: 'Europe/Belgrade',
        displayName: 'GMT+01:00 貝爾格勒 CET',
        nameLocalized: '貝爾格勒',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 394
    },
    {
        name: 'Africa/Lagos',
        displayName: 'GMT+01:00 拉哥斯 WAT',
        nameLocalized: '拉哥斯',
        abbreviationStandard: 'WAT',
        id: 31
    },
    {
        name: 'Europe/Podgorica',
        displayName: 'GMT+01:00 波多里察 CET',
        nameLocalized: '波多里察',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 424
    },
    {
        name: 'Africa/Porto-Novo',
        displayName: 'GMT+01:00 波多諾佛 WAT',
        nameLocalized: '波多諾佛',
        abbreviationStandard: 'WAT',
        id: 48,
        enabled: true
    },
    {
        name: 'Europe/Gibraltar',
        displayName: 'GMT+01:00 直布羅陀 CET',
        nameLocalized: '直布羅陀',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 403
    },
    {
        name: 'Africa/Kinshasa',
        displayName: 'GMT+01:00 金夏沙 WAT',
        nameLocalized: '金夏沙',
        abbreviationStandard: 'WAT',
        id: 30
    },
    {
        name: 'Africa/El_Aaiun',
        displayName: 'GMT+01:00 阿尤恩 +01/+00',
        nameLocalized: '阿尤恩',
        abbreviationStandard: '+01/+00',
        id: 22
    },
    {
        name: 'Europe/Amsterdam',
        displayName: 'GMT+01:00 阿姆斯特丹 CET',
        nameLocalized: '阿姆斯特丹',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 390,
        enabled: true
    },
    {
        name: 'Africa/Algiers',
        displayName: 'GMT+01:00 阿爾及爾 CET',
        nameLocalized: '阿爾及爾',
        abbreviationStandard: 'CET',
        id: 4
    },
    {
        name: 'Europe/Berlin',
        displayName: 'GMT+01:00 柏林 CET',
        nameLocalized: '柏林',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 395
    },
    {
        name: 'Africa/Tunis',
        displayName: 'GMT+01:00 突尼斯 CEST',
        nameLocalized: '突尼斯',
        abbreviationStandard: 'CEST',
        id: 52
    },
    {
        name: 'Europe/Copenhagen',
        displayName: 'GMT+01:00 哥本哈根 CET',
        nameLocalized: '哥本哈根',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 401
    },
    {
        name: 'Africa/Ndjamena',
        displayName: 'GMT+01:00 恩賈梅納 WAT',
        nameLocalized: '恩賈梅納',
        abbreviationStandard: 'WAT',
        id: 44
    },
    {
        name: 'Africa/Bangui',
        displayName: 'GMT+01:00 班吉 WAT',
        nameLocalized: '班吉',
        abbreviationStandard: 'WAT',
        id: 8
    },
    {
        name: 'Africa/Malabo',
        displayName: 'GMT+01:00 馬拉博 WAT',
        nameLocalized: '馬拉博',
        abbreviationStandard: 'WAT',
        id: 37
    },
    {
        name: 'Europe/Malta',
        displayName: 'GMT+01:00 馬爾他 CET',
        nameLocalized: '馬爾他',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 416
    },
    {
        name: 'Europe/Madrid',
        displayName: 'GMT+01:00 馬德里 CET',
        nameLocalized: '馬德里',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 415,
        enabled: true
    },
    {
        name: 'Europe/Vatican',
        displayName: 'GMT+01:00 梵蒂岡 CET',
        nameLocalized: '梵蒂岡',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 440
    },
    {
        name: 'Europe/Dublin',
        displayName: 'GMT+01:00 都柏林 IST/GMT',
        nameLocalized: '都柏林',
        abbreviationStandard: 'IST/GMT',
        id: 402
    },
    {
        name: 'Europe/Stockholm',
        displayName: 'GMT+01:00 斯德哥爾摩 CET',
        nameLocalized: '斯德哥爾摩',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 434
    },
    {
        name: 'Europe/Warsaw',
        displayName: 'GMT+01:00 華沙 CET',
        nameLocalized: '華沙',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 444
    },
    {
        name: 'Arctic/Longyearbyen',
        displayName: 'GMT+01:00 隆意耳拜恩 CET',
        nameLocalized: '隆意耳拜恩',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 212
    },
    {
        name: 'Europe/Sarajevo',
        displayName: 'GMT+01:00 塞拉耶佛 CET',
        nameLocalized: '塞拉耶佛',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 430,
        enabled: true
    },
    {
        name: 'Europe/Oslo',
        displayName: 'GMT+01:00 奧斯陸 CET',
        nameLocalized: '奧斯陸',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 422
    },
    {
        name: 'Europe/San_Marino',
        displayName: 'GMT+01:00 聖馬利諾 CET',
        nameLocalized: '聖馬利諾',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 429
    },
    {
        name: 'Europe/Vienna',
        displayName: 'GMT+01:00 維也納 CET',
        nameLocalized: '維也納',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 441
    },
    {
        name: 'Europe/Monaco',
        displayName: 'GMT+01:00 摩納哥 CET',
        nameLocalized: '摩納哥',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 419
    },
    {
        name: 'Europe/Ljubljana',
        displayName: 'GMT+01:00 盧比安納 CET',
        nameLocalized: '盧比安納',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 412
    },
    {
        name: 'Europe/Luxembourg',
        displayName: 'GMT+01:00 盧森堡 CET',
        nameLocalized: '盧森堡',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 414
    },
    {
        name: 'Africa/Luanda',
        displayName: 'GMT+01:00 羅安達 WAT',
        nameLocalized: '羅安達',
        abbreviationStandard: 'WAT',
        id: 34
    },
    {
        name: 'Europe/Rome',
        displayName: 'GMT+01:00 羅馬 CET',
        nameLocalized: '羅馬',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 427
    },
    {
        name: 'Europe/Zurich',
        displayName: 'GMT+01:00 蘇黎世 CET',
        nameLocalized: '蘇黎世',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 447
    },
    {
        name: 'CET',
        displayName: 'GMT+01:00 CET CET',
        nameLocalized: 'CET',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 345
    },
    {
        name: 'MET',
        displayName: 'GMT+01:00 MET MET',
        nameLocalized: 'MET',
        abbreviationStandard: 'MET',
        abbreviationDaylight: 'MEST',
        id: 476
    },
    {
        name: 'America/Danmarkshavn',
        displayName: 'GMT+00:00 丹馬沙文 GMT',
        nameLocalized: '丹馬沙文',
        abbreviationStandard: 'GMT',
        id: 97
    },
    {
        name: 'Africa/Bamako',
        displayName: 'GMT+00:00 巴馬科 GMT',
        nameLocalized: '巴馬科',
        abbreviationStandard: 'GMT',
        id: 7
    },
    {
        name: 'Africa/Bissau',
        displayName: 'GMT+00:00 比紹 GMT',
        nameLocalized: '比紹',
        abbreviationStandard: 'GMT',
        id: 10
    },
    {
        name: 'Atlantic/Canary',
        displayName: 'GMT+00:00 加納利 WET',
        nameLocalized: '加納利',
        abbreviationStandard: 'WET',
        abbreviationDaylight: 'WEST',
        id: 299
    },
    {
        name: 'Asia/Calcutta',
        displayName: 'GMT+00:00 加爾各答 UTC',
        nameLocalized: '加爾各答',
        abbreviationStandard: 'UTC',
        id: 228,
        enabled: true
    },
    {
        name: 'Asia/Katmandu',
        displayName: 'GMT+00:00 加德滿都 UTC',
        nameLocalized: '加德滿都',
        abbreviationStandard: 'UTC',
        id: 252,
        enabled: true
    },
    {
        name: 'Africa/Ouagadougou',
        displayName: 'GMT+00:00 瓦加杜古 GMT',
        nameLocalized: '瓦加杜古',
        abbreviationStandard: 'GMT',
        id: 47
    },
    {
        name: 'Asia/Rangoon',
        displayName: 'GMT+00:00 仰光 UTC',
        nameLocalized: '仰光',
        abbreviationStandard: 'UTC',
        id: 272,
        enabled: true
    },
    {
        name: 'Africa/Freetown',
        displayName: 'GMT+00:00 自由城 GMT',
        nameLocalized: '自由城',
        abbreviationStandard: 'GMT',
        id: 23
    },
    {
        name: 'Europe/Lisbon',
        displayName: 'GMT+00:00 里斯本 WET',
        nameLocalized: '里斯本',
        abbreviationStandard: 'WET',
        abbreviationDaylight: 'WEST',
        id: 411
    },
    {
        name: 'Atlantic/Faeroe',
        displayName: 'GMT+00:00 法羅群島 UTC',
        nameLocalized: '法羅群島',
        abbreviationStandard: 'UTC',
        id: 301
    },
    {
        name: 'Africa/Abidjan',
        displayName: 'GMT+00:00 阿比讓 GMT',
        nameLocalized: '阿比讓',
        abbreviationStandard: 'GMT',
        id: 1
    },
    {
        name: 'Africa/Accra',
        displayName: 'GMT+00:00 阿克拉 GMT',
        nameLocalized: '阿克拉',
        abbreviationStandard: 'GMT',
        id: 2
    },
    {
        name: 'Africa/Conakry',
        displayName: 'GMT+00:00 柯那克里 GMT',
        nameLocalized: '柯那克里',
        abbreviationStandard: 'GMT',
        id: 17
    },
    {
        name: 'Africa/Lome',
        displayName: 'GMT+00:00 洛美 GMT',
        nameLocalized: '洛美',
        abbreviationStandard: 'GMT',
        id: 33
    },
    {
        name: 'Europe/London',
        displayName: 'GMT+00:00 倫敦 GMT/BST',
        nameLocalized: '倫敦',
        abbreviationStandard: 'GMT/BST',
        abbreviationDaylight: 'GMT/BST',
        id: 413,
        enabled: true
    },
    {
        name: 'Pacific/Enderbury',
        displayName: 'GMT+00:00 恩得伯理島 -00',
        nameLocalized: '恩得伯理島',
        abbreviationStandard: '-00',
        id: 490
    },
    {
        name: 'Europe/Guernsey',
        displayName: 'GMT+00:00 根息島 GMT/BST',
        nameLocalized: '根息島',
        abbreviationStandard: 'GMT/BST',
        abbreviationDaylight: 'GMT/BST',
        id: 404
    },
    {
        name: 'Africa/Banjul',
        displayName: 'GMT+00:00 班竹 GMT',
        nameLocalized: '班竹',
        abbreviationStandard: 'GMT',
        id: 9
    },
    {
        name: 'Atlantic/Madeira',
        displayName: 'GMT+00:00 馬得拉群島 WET',
        nameLocalized: '馬得拉群島',
        abbreviationStandard: 'WET',
        abbreviationDaylight: 'WEST',
        id: 304
    },
    {
        name: 'Europe/Isle_of_Man',
        displayName: 'GMT+00:00 曼島 GMT/BST',
        nameLocalized: '曼島',
        abbreviationStandard: 'GMT/BST',
        abbreviationDaylight: 'GMT/BST',
        id: 406
    },
    {
        name: 'Africa/Sao_Tome',
        displayName: 'GMT+00:00 聖多美 GMT',
        nameLocalized: '聖多美',
        abbreviationStandard: 'GMT',
        id: 49
    },
    {
        name: 'Atlantic/St_Helena',
        displayName: 'GMT+00:00 聖赫勒拿島 GMT',
        nameLocalized: '聖赫勒拿島',
        abbreviationStandard: 'GMT',
        id: 307
    },
    {
        name: 'Africa/Dakar',
        displayName: 'GMT+00:00 達喀爾 GMT',
        nameLocalized: '達喀爾',
        abbreviationStandard: 'GMT',
        id: 18
    },
    {
        name: 'Atlantic/Reykjavik',
        displayName: 'GMT+00:00 雷克雅維克 GMT',
        nameLocalized: '雷克雅維克',
        abbreviationStandard: 'GMT',
        id: 305
    },
    {
        name: 'Africa/Monrovia',
        displayName: 'GMT+00:00 蒙羅維亞 GMT',
        nameLocalized: '蒙羅維亞',
        abbreviationStandard: 'GMT',
        id: 42
    },
    {
        name: 'Europe/Jersey',
        displayName: 'GMT+00:00 澤西島 GMT/BST',
        nameLocalized: '澤西島',
        abbreviationStandard: 'GMT/BST',
        abbreviationDaylight: 'GMT/BST',
        id: 408
    },
    {
        name: 'Africa/Nouakchott',
        displayName: 'GMT+00:00 諾克少 GMT',
        nameLocalized: '諾克少',
        abbreviationStandard: 'GMT',
        id: 46
    },
    {
        name: 'US/Aleutian',
        displayName: 'GMT+00:00 Aleutian UTC',
        nameLocalized: 'Aleutian',
        abbreviationStandard: 'UTC',
        id: 536
    },
    {
        name: 'US/Arizona',
        displayName: 'GMT+00:00 Arizona UTC',
        nameLocalized: 'Arizona',
        abbreviationStandard: 'UTC',
        id: 537
    },
    {
        name: 'Asia/Ashkhabad',
        displayName: 'GMT+00:00 Ashkhabad UTC',
        nameLocalized: 'Ashkhabad',
        abbreviationStandard: 'UTC',
        id: 220
    },
    {
        name: 'America/Atka',
        displayName: 'GMT+00:00 Atka UTC',
        nameLocalized: 'Atka',
        abbreviationStandard: 'UTC',
        id: 73
    },
    {
        name: 'Canada/Atlantic',
        displayName: 'GMT+00:00 Atlantic UTC',
        nameLocalized: 'Atlantic',
        abbreviationStandard: 'UTC',
        id: 336
    },
    {
        name: 'Mexico/BajaNorte',
        displayName: 'GMT+00:00 BajaNorte UTC',
        nameLocalized: 'BajaNorte',
        abbreviationStandard: 'UTC',
        id: 477
    },
    {
        name: 'Europe/Belfast',
        displayName: 'GMT+00:00 Belfast GMT/BST',
        nameLocalized: 'Belfast',
        abbreviationStandard: 'GMT/BST',
        abbreviationDaylight: 'GMT/BST',
        id: 393
    },
    {
        name: 'US/Central',
        displayName: 'GMT+00:00 Central UTC',
        nameLocalized: 'Central',
        abbreviationStandard: 'UTC',
        id: 538
    },
    {
        name: 'Cuba',
        displayName: 'GMT+00:00 Cuba UTC',
        nameLocalized: 'Cuba',
        abbreviationStandard: 'UTC',
        id: 349
    },
    {
        name: 'Asia/Dacca',
        displayName: 'GMT+00:00 Dacca UTC',
        nameLocalized: 'Dacca',
        abbreviationStandard: 'UTC',
        id: 233
    },
    {
        name: 'Brazil/DeNoronha',
        displayName: 'GMT+00:00 DeNoronha UTC',
        nameLocalized: 'DeNoronha',
        abbreviationStandard: 'UTC',
        id: 333
    },
    {
        name: 'Canada/East-Saskatchewan',
        displayName: 'GMT+00:00 East-Saskatchewan UTC',
        nameLocalized: 'East-Saskatchewan',
        abbreviationStandard: 'UTC',
        id: 338
    },
    {
        name: 'Chile/EasterIsland',
        displayName: 'GMT+00:00 EasterIsland UTC',
        nameLocalized: 'EasterIsland',
        abbreviationStandard: 'UTC',
        id: 347
    },
    {
        name: 'Canada/Eastern',
        displayName: 'GMT+00:00 Eastern UTC',
        nameLocalized: 'Eastern',
        abbreviationStandard: 'UTC',
        id: 339
    },
    {
        name: 'Egypt',
        displayName: 'GMT+00:00 Egypt UTC',
        nameLocalized: 'Egypt',
        abbreviationStandard: 'UTC',
        id: 351
    },
    {
        name: 'Eire',
        displayName: 'GMT+00:00 Eire UTC',
        nameLocalized: 'Eire',
        abbreviationStandard: 'UTC',
        id: 352
    },
    {
        name: 'Factory',
        displayName: 'GMT+00:00 Factory -00',
        nameLocalized: 'Factory',
        abbreviationStandard: '-00',
        id: 448
    },
    {
        name: 'Atlantic/Faroe',
        displayName: 'GMT+00:00 Faroe WET',
        nameLocalized: 'Faroe',
        abbreviationStandard: 'WET',
        abbreviationDaylight: 'WEST',
        id: 302
    },
    {
        name: 'GB',
        displayName: 'GMT+00:00 GB UTC',
        nameLocalized: 'GB',
        abbreviationStandard: 'UTC',
        id: 449
    },
    {
        name: 'GB-Eire',
        displayName: 'GMT+00:00 GB-Eire UTC',
        nameLocalized: 'GB-Eire',
        abbreviationStandard: 'UTC',
        id: 450
    },
    {
        name: 'Etc/GMT',
        displayName: 'GMT+00:00 GMT GMT',
        nameLocalized: 'GMT',
        abbreviationStandard: 'GMT',
        id: 355
    },
    {
        name: 'GMT',
        displayName: 'GMT+00:00 GMT UTC',
        nameLocalized: 'GMT',
        abbreviationStandard: 'UTC',
        id: 451
    },
    {
        name: 'Etc/GMT-0',
        displayName: 'GMT+00:00 GMT-0 UTC',
        nameLocalized: 'GMT-0',
        abbreviationStandard: 'UTC',
        id: 369
    },
    {
        name: 'GMT-0',
        displayName: 'GMT+00:00 GMT-0 UTC',
        nameLocalized: 'GMT-0',
        abbreviationStandard: 'UTC',
        id: 453
    },
    {
        name: 'Etc/GMT+0',
        displayName: 'GMT+00:00 GMT+0 UTC',
        nameLocalized: 'GMT+0',
        abbreviationStandard: 'UTC',
        id: 356
    },
    {
        name: 'GMT+0',
        displayName: 'GMT+00:00 GMT+0 UTC',
        nameLocalized: 'GMT+0',
        abbreviationStandard: 'UTC',
        id: 452
    },
    {
        name: 'Etc/GMT0',
        displayName: 'GMT+00:00 GMT0 UTC',
        nameLocalized: 'GMT0',
        abbreviationStandard: 'UTC',
        id: 384
    },
    {
        name: 'GMT0',
        displayName: 'GMT+00:00 GMT0 UTC',
        nameLocalized: 'GMT0',
        abbreviationStandard: 'UTC',
        id: 454
    },
    {
        name: 'Etc/Greenwich',
        displayName: 'GMT+00:00 Greenwich UTC',
        nameLocalized: 'Greenwich',
        abbreviationStandard: 'UTC',
        id: 385
    },
    {
        name: 'Greenwich',
        displayName: 'GMT+00:00 Greenwich UTC',
        nameLocalized: 'Greenwich',
        abbreviationStandard: 'UTC',
        id: 455
    },
    {
        name: 'Hongkong',
        displayName: 'GMT+00:00 Hongkong UTC',
        nameLocalized: 'Hongkong',
        abbreviationStandard: 'UTC',
        id: 456
    },
    {
        name: 'Iceland',
        displayName: 'GMT+00:00 Iceland GMT',
        nameLocalized: 'Iceland',
        abbreviationStandard: 'GMT',
        id: 458
    },
    {
        name: 'Iran',
        displayName: 'GMT+00:00 Iran UTC',
        nameLocalized: 'Iran',
        abbreviationStandard: 'UTC',
        id: 470
    },
    {
        name: 'Israel',
        displayName: 'GMT+00:00 Israel UTC',
        nameLocalized: 'Israel',
        abbreviationStandard: 'UTC',
        id: 471
    },
    {
        name: 'Jamaica',
        displayName: 'GMT+00:00 Jamaica UTC',
        nameLocalized: 'Jamaica',
        abbreviationStandard: 'UTC',
        id: 472
    },
    {
        name: 'Japan',
        displayName: 'GMT+00:00 Japan UTC',
        nameLocalized: 'Japan',
        abbreviationStandard: 'UTC',
        id: 473
    },
    {
        name: 'Libya',
        displayName: 'GMT+00:00 Libya UTC',
        nameLocalized: 'Libya',
        abbreviationStandard: 'UTC',
        id: 475
    },
    {
        name: 'Asia/Macao',
        displayName: 'GMT+00:00 Macao UTC',
        nameLocalized: 'Macao',
        abbreviationStandard: 'UTC',
        id: 257
    },
    {
        name: 'US/Michigan',
        displayName: 'GMT+00:00 Michigan UTC',
        nameLocalized: 'Michigan',
        abbreviationStandard: 'UTC',
        id: 543
    },
    {
        name: 'US/Mountain',
        displayName: 'GMT+00:00 Mountain UTC',
        nameLocalized: 'Mountain',
        abbreviationStandard: 'UTC',
        id: 544
    },
    {
        name: 'Navajo',
        displayName: 'GMT+00:00 Navajo UTC',
        nameLocalized: 'Navajo',
        abbreviationStandard: 'UTC',
        id: 482
    },
    {
        name: 'NZ-CHAT',
        displayName: 'GMT+00:00 NZ-CHAT UTC',
        nameLocalized: 'NZ-CHAT',
        abbreviationStandard: 'UTC',
        id: 484
    },
    {
        name: 'US/Pacific-New',
        displayName: 'GMT+00:00 Pacific-New UTC',
        nameLocalized: 'Pacific-New',
        abbreviationStandard: 'UTC',
        id: 546
    },
    {
        name: 'Poland',
        displayName: 'GMT+00:00 Poland UTC',
        nameLocalized: 'Poland',
        abbreviationStandard: 'UTC',
        id: 525
    },
    {
        name: 'Portugal',
        displayName: 'GMT+00:00 Portugal UTC',
        nameLocalized: 'Portugal',
        abbreviationStandard: 'UTC',
        id: 526
    },
    {
        name: 'PRC',
        displayName: 'GMT+00:00 PRC UTC',
        nameLocalized: 'PRC',
        abbreviationStandard: 'UTC',
        id: 527
    },
    {
        name: 'ROC',
        displayName: 'GMT+00:00 ROC UTC',
        nameLocalized: 'ROC',
        abbreviationStandard: 'UTC',
        id: 529
    },
    {
        name: 'ROK',
        displayName: 'GMT+00:00 ROK UTC',
        nameLocalized: 'ROK',
        abbreviationStandard: 'UTC',
        id: 530
    },
    {
        name: 'Canada/Saskatchewan',
        displayName: 'GMT+00:00 Saskatchewan UTC',
        nameLocalized: 'Saskatchewan',
        abbreviationStandard: 'UTC',
        id: 343,
        enabled: true
    },
    {
        name: 'America/Shiprock',
        displayName: 'GMT+00:00 Shiprock UTC',
        nameLocalized: 'Shiprock',
        abbreviationStandard: 'UTC',
        id: 183
    },
    {
        name: 'Singapore',
        displayName: 'GMT+00:00 Singapore UTC',
        nameLocalized: 'Singapore',
        abbreviationStandard: 'UTC',
        id: 531
    },
    {
        name: 'Asia/Thimbu',
        displayName: 'GMT+00:00 Thimbu UTC',
        nameLocalized: 'Thimbu',
        abbreviationStandard: 'UTC',
        id: 285
    },
    {
        name: 'Africa/Timbuktu',
        displayName: 'GMT+00:00 Timbuktu GMT',
        nameLocalized: 'Timbuktu',
        abbreviationStandard: 'GMT',
        id: 50
    },
    {
        name: 'Turkey',
        displayName: 'GMT+00:00 Turkey UTC',
        nameLocalized: 'Turkey',
        abbreviationStandard: 'UTC',
        id: 532
    },
    {
        name: 'Etc/UCT',
        displayName: 'GMT+00:00 UCT UTC',
        nameLocalized: 'UCT',
        abbreviationStandard: 'UTC',
        id: 386
    },
    {
        name: 'UCT',
        displayName: 'GMT+00:00 UCT UTC',
        nameLocalized: 'UCT',
        abbreviationStandard: 'UTC',
        id: 533
    },
    {
        name: 'Asia/Ujung_Pandang',
        displayName: 'GMT+00:00 Ujung Pandang UTC',
        nameLocalized: 'Ujung Pandang',
        abbreviationStandard: 'UTC',
        id: 288
    },
    {
        name: 'Etc/Universal',
        displayName: 'GMT+00:00 Universal UTC',
        nameLocalized: 'Universal',
        abbreviationStandard: 'UTC',
        id: 387
    },
    {
        name: 'Universal',
        displayName: 'GMT+00:00 Universal UTC',
        nameLocalized: 'Universal',
        abbreviationStandard: 'UTC',
        id: 534
    },
    {
        name: 'Etc/UTC',
        displayName: 'GMT+00:00 UTC UTC',
        nameLocalized: 'UTC',
        abbreviationStandard: 'UTC',
        id: 388
    },
    {
        name: 'UTC',
        displayName: 'GMT+00:00 UTC UTC',
        nameLocalized: 'UTC',
        abbreviationStandard: 'UTC',
        id: 548
    },
    {
        name: 'W-SU',
        displayName: 'GMT+00:00 W-SU UTC',
        nameLocalized: 'W-SU',
        abbreviationStandard: 'UTC',
        id: 549
    },
    {
        name: 'Australia/West',
        displayName: 'GMT+00:00 West UTC',
        nameLocalized: 'West',
        abbreviationStandard: 'UTC',
        id: 330
    },
    {
        name: 'Brazil/West',
        displayName: 'GMT+00:00 West UTC',
        nameLocalized: 'West',
        abbreviationStandard: 'UTC',
        id: 335
    },
    {
        name: 'WET',
        displayName: 'GMT+00:00 WET WET',
        nameLocalized: 'WET',
        abbreviationStandard: 'WET',
        abbreviationDaylight: 'WEST',
        id: 550
    },
    {
        name: 'Etc/Zulu',
        displayName: 'GMT+00:00 Zulu UTC',
        nameLocalized: 'Zulu',
        abbreviationStandard: 'UTC',
        id: 389
    },
    {
        name: 'Zulu',
        displayName: 'GMT+00:00 Zulu UTC',
        nameLocalized: 'Zulu',
        abbreviationStandard: 'UTC',
        id: 551,
        enabled: true
    },
    {
        name: 'Atlantic/Azores',
        displayName: 'GMT-01:00 亞速爾群島 -01/+00',
        nameLocalized: '亞速爾群島',
        abbreviationStandard: '-01/+00',
        abbreviationDaylight: '-01/+00',
        id: 297,
        enabled: true
    },
    {
        name: 'Atlantic/Cape_Verde',
        displayName: 'GMT-01:00 維德角 -01',
        nameLocalized: '維德角',
        abbreviationStandard: '-01',
        id: 300,
        enabled: true
    },
    {
        name: 'Etc/GMT-1',
        displayName: 'GMT-01:00 GMT-1 -01',
        nameLocalized: 'GMT-1',
        abbreviationStandard: '-01',
        id: 370
    },
    {
        name: 'Etc/GMT+1',
        displayName: 'GMT-01:00 GMT+1 -01',
        nameLocalized: 'GMT+1',
        abbreviationStandard: '-01',
        id: 357
    },
    {
        name: 'Atlantic/Jan_Mayen',
        displayName: 'GMT-01:00 Jan Mayen -01',
        nameLocalized: 'Jan Mayen',
        abbreviationStandard: '-01',
        id: 303
    },
    {
        name: 'America/Scoresbysund',
        displayName: 'GMT-02:00 伊托科爾托米特 -02/-01',
        nameLocalized: '伊托科爾托米特',
        abbreviationStandard: '-02/-01',
        abbreviationDaylight: '-02/-01',
        id: 182
    },
    {
        name: 'Atlantic/South_Georgia',
        displayName: 'GMT-02:00 南喬治亞 -02',
        nameLocalized: '南喬治亞',
        abbreviationStandard: '-02',
        id: 306,
        enabled: true
    },
    {
        name: 'America/Noronha',
        displayName: 'GMT-02:00 諾倫哈 -02',
        nameLocalized: '諾倫哈',
        abbreviationStandard: '-02',
        id: 160
    },
    {
        name: 'Etc/GMT-2',
        displayName: 'GMT-02:00 GMT-2 -02',
        nameLocalized: 'GMT-2',
        abbreviationStandard: '-02',
        id: 376
    },
    {
        name: 'Etc/GMT+2',
        displayName: 'GMT-02:00 GMT+2 -02',
        nameLocalized: 'GMT+2',
        abbreviationStandard: '-02',
        id: 361
    },
    {
        name: 'America/St_Johns',
        displayName: 'GMT-03:30 聖約翰 NST',
        nameLocalized: '聖約翰',
        abbreviationStandard: 'NST',
        abbreviationDaylight: 'NDT',
        id: 184,
        enabled: true
    },
    {
        name: 'Canada/Newfoundland',
        displayName: 'GMT-03:30 Newfoundland NST',
        nameLocalized: 'Newfoundland',
        abbreviationStandard: 'NST',
        abbreviationDaylight: 'NDT',
        id: 341
    },
    {
        name: 'America/Bahia',
        displayName: 'GMT-03:00 巴伊阿 -03',
        nameLocalized: '巴伊阿',
        abbreviationStandard: '-03',
        id: 74
    },
    {
        name: 'America/Paramaribo',
        displayName: 'GMT-03:00 巴拉馬利波 -03',
        nameLocalized: '巴拉馬利波',
        abbreviationStandard: '-03',
        id: 165
    },
    {
        name: 'America/Catamarca',
        displayName: 'GMT-03:00 卡塔馬卡 -03',
        nameLocalized: '卡塔馬卡',
        abbreviationStandard: '-03',
        id: 87
    },
    {
        name: 'Atlantic/Stanley',
        displayName: 'GMT-03:00 史坦利 -03',
        nameLocalized: '史坦利',
        abbreviationStandard: '-03',
        id: 308
    },
    {
        name: 'America/Buenos_Aires',
        displayName: 'GMT-03:00 布宜諾斯艾利斯 -03/-02',
        nameLocalized: '布宜諾斯艾利斯',
        abbreviationStandard: '-03/-02',
        id: 82,
        enabled: true
    },
    {
        name: 'America/Argentina/Tucuman',
        displayName: 'GMT-03:00 吐庫曼 -03/-02',
        nameLocalized: '吐庫曼',
        abbreviationStandard: '-03/-02',
        id: 68
    },
    {
        name: 'America/Godthab',
        displayName: 'GMT-03:00 努克 -03/-02',
        nameLocalized: '努克',
        abbreviationStandard: '-03/-02',
        abbreviationDaylight: '-03/-02',
        id: 110,
        enabled: true
    },
    {
        name: 'America/Belem',
        displayName: 'GMT-03:00 貝倫 -03',
        nameLocalized: '貝倫',
        abbreviationStandard: '-03',
        id: 76
    },
    {
        name: 'America/Argentina/Rio_Gallegos',
        displayName: 'GMT-03:00 里奧加耶戈斯 -03',
        nameLocalized: '里奧加耶戈斯',
        abbreviationStandard: '-03',
        id: 66
    },
    {
        name: 'Antarctica/Palmer',
        displayName: 'GMT-03:00 帕麥 -03',
        nameLocalized: '帕麥',
        abbreviationStandard: '-03',
        id: 207
    },
    {
        name: 'America/Argentina/La_Rioja',
        displayName: 'GMT-03:00 拉略哈 -03',
        nameLocalized: '拉略哈',
        abbreviationStandard: '-03',
        id: 64
    },
    {
        name: 'America/Mendoza',
        displayName: 'GMT-03:00 門多薩 -03',
        nameLocalized: '門多薩',
        abbreviationStandard: '-03',
        id: 146
    },
    {
        name: 'America/Araguaina',
        displayName: 'GMT-03:00 阿拉圭那 -03',
        nameLocalized: '阿拉圭那',
        abbreviationStandard: '-03',
        id: 58
    },
    {
        name: 'America/Jujuy',
        displayName: 'GMT-03:00 胡胡伊 -03',
        nameLocalized: '胡胡伊',
        abbreviationStandard: '-03',
        id: 132
    },
    {
        name: 'America/Cordoba',
        displayName: 'GMT-03:00 哥多華 -03/-02',
        nameLocalized: '哥多華',
        abbreviationStandard: '-03/-02',
        id: 93
    },
    {
        name: 'America/Argentina/Ushuaia',
        displayName: 'GMT-03:00 烏斯懷亞 -03',
        nameLocalized: '烏斯懷亞',
        abbreviationStandard: '-03',
        id: 69
    },
    {
        name: 'America/Maceio',
        displayName: 'GMT-03:00 馬瑟歐 -03',
        nameLocalized: '馬瑟歐',
        abbreviationStandard: '-03',
        id: 141
    },
    {
        name: 'America/Miquelon',
        displayName: 'GMT-03:00 密啟崙 -03/-02',
        nameLocalized: '密啟崙',
        abbreviationStandard: '-03/-02',
        abbreviationDaylight: '-03/-02',
        id: 150
    },
    {
        name: 'America/Cayenne',
        displayName: 'GMT-03:00 開雲 -03',
        nameLocalized: '開雲',
        abbreviationStandard: '-03',
        id: 88
    },
    {
        name: 'America/Sao_Paulo',
        displayName: 'GMT-03:00 聖保羅 -03/-02',
        nameLocalized: '聖保羅',
        abbreviationStandard: '-03/-02',
        id: 181,
        enabled: true
    },
    {
        name: 'America/Argentina/San_Juan',
        displayName: 'GMT-03:00 聖胡安 -03',
        nameLocalized: '聖胡安',
        abbreviationStandard: '-03',
        id: 67
    },
    {
        name: 'America/Recife',
        displayName: 'GMT-03:00 雷西非 -03',
        nameLocalized: '雷西非',
        abbreviationStandard: '-03',
        id: 174
    },
    {
        name: 'America/Fortaleza',
        displayName: 'GMT-03:00 福塔力莎 -03',
        nameLocalized: '福塔力莎',
        abbreviationStandard: '-03',
        id: 108
    },
    {
        name: 'America/Montevideo',
        displayName: 'GMT-03:00 蒙特維多 -03/-02',
        nameLocalized: '蒙特維多',
        abbreviationStandard: '-03/-02',
        id: 153,
        enabled: true
    },
    {
        name: 'Antarctica/Rothera',
        displayName: 'GMT-03:00 羅瑟拉 -03',
        nameLocalized: '羅瑟拉',
        abbreviationStandard: '-03',
        id: 208
    },
    {
        name: 'America/Argentina/Buenos_Aires',
        displayName: 'GMT-03:00 Buenos Aires -03/-02',
        nameLocalized: 'Buenos Aires',
        abbreviationStandard: '-03/-02',
        id: 59
    },
    {
        name: 'America/Argentina/Catamarca',
        displayName: 'GMT-03:00 Catamarca -03',
        nameLocalized: 'Catamarca',
        abbreviationStandard: '-03',
        id: 60
    },
    {
        name: 'America/Argentina/ComodRivadavia',
        displayName: 'GMT-03:00 ComodRivadavia -03',
        nameLocalized: 'ComodRivadavia',
        abbreviationStandard: '-03',
        id: 61
    },
    {
        name: 'America/Argentina/Cordoba',
        displayName: 'GMT-03:00 Cordoba -03/-02',
        nameLocalized: 'Cordoba',
        abbreviationStandard: '-03/-02',
        id: 62
    },
    {
        name: 'Brazil/East',
        displayName: 'GMT-03:00 East -03/-02',
        nameLocalized: 'East',
        abbreviationStandard: '-03/-02',
        id: 334
    },
    {
        name: 'Etc/GMT-3',
        displayName: 'GMT-03:00 GMT-3 -03',
        nameLocalized: 'GMT-3',
        abbreviationStandard: '-03',
        id: 377
    },
    {
        name: 'Etc/GMT+3',
        displayName: 'GMT-03:00 GMT+3 -03',
        nameLocalized: 'GMT+3',
        abbreviationStandard: '-03',
        id: 362
    },
    {
        name: 'America/Argentina/Jujuy',
        displayName: 'GMT-03:00 Jujuy -03',
        nameLocalized: 'Jujuy',
        abbreviationStandard: '-03',
        id: 63
    },
    {
        name: 'America/Argentina/Mendoza',
        displayName: 'GMT-03:00 Mendoza -03',
        nameLocalized: 'Mendoza',
        abbreviationStandard: '-03',
        id: 65
    },
    {
        name: 'America/Rosario',
        displayName: 'GMT-03:00 Rosario -03/-02',
        nameLocalized: 'Rosario',
        abbreviationStandard: '-03/-02',
        id: 178
    },
    {
        name: 'America/Barbados',
        displayName: 'GMT-04:00 巴貝多 AST',
        nameLocalized: '巴貝多',
        abbreviationStandard: 'AST',
        id: 75
    },
    {
        name: 'America/Caracas',
        displayName: 'GMT-04:00 卡拉卡斯 -04',
        nameLocalized: '卡拉卡斯',
        abbreviationStandard: '-04',
        id: 86,
        enabled: true
    },
    {
        name: 'America/Cuiaba',
        displayName: 'GMT-04:00 古雅巴 -04/-03',
        nameLocalized: '古雅巴',
        abbreviationStandard: '-04/-03',
        id: 95
    },
    {
        name: 'America/Guadeloupe',
        displayName: 'GMT-04:00 瓜地洛普 AST',
        nameLocalized: '瓜地洛普',
        abbreviationStandard: 'AST',
        id: 114
    },
    {
        name: 'America/Blanc-Sablon',
        displayName: 'GMT-04:00 白朗薩布隆 AST',
        nameLocalized: '白朗薩布隆',
        abbreviationStandard: 'AST',
        id: 78
    },
    {
        name: 'America/Dominica',
        displayName: 'GMT-04:00 多米尼克 AST',
        nameLocalized: '多米尼克',
        abbreviationStandard: 'AST',
        id: 102
    },
    {
        name: 'America/Antigua',
        displayName: 'GMT-04:00 安地卡 AST',
        nameLocalized: '安地卡',
        abbreviationStandard: 'AST',
        id: 57
    },
    {
        name: 'America/Anguilla',
        displayName: 'GMT-04:00 安奎拉 AST',
        nameLocalized: '安奎拉',
        abbreviationStandard: 'AST',
        id: 56
    },
    {
        name: 'America/Tortola',
        displayName: 'GMT-04:00 托爾托拉 AST',
        nameLocalized: '托爾托拉',
        abbreviationStandard: 'AST',
        id: 195
    },
    {
        name: 'Atlantic/Bermuda',
        displayName: 'GMT-04:00 百慕達 AST',
        nameLocalized: '百慕達',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 298
    },
    {
        name: 'America/Port_of_Spain',
        displayName: 'GMT-04:00 西班牙港 AST',
        nameLocalized: '西班牙港',
        abbreviationStandard: 'AST',
        id: 168
    },
    {
        name: 'America/Thule',
        displayName: 'GMT-04:00 杜里 AST',
        nameLocalized: '杜里',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 191
    },
    {
        name: 'America/Asuncion',
        displayName: 'GMT-04:00 亞松森 -04/-03',
        nameLocalized: '亞松森',
        abbreviationStandard: '-04/-03',
        abbreviationDaylight: '-04/-03',
        id: 71
    },
    {
        name: 'America/La_Paz',
        displayName: 'GMT-04:00 拉巴斯 -04',
        nameLocalized: '拉巴斯',
        abbreviationStandard: '-04',
        id: 137,
        enabled: true
    },
    {
        name: 'America/Puerto_Rico',
        displayName: 'GMT-04:00 波多黎各 AST',
        nameLocalized: '波多黎各',
        abbreviationStandard: 'AST',
        id: 171
    },
    {
        name: 'America/Boa_Vista',
        displayName: 'GMT-04:00 保維斯塔 -04',
        nameLocalized: '保維斯塔',
        abbreviationStandard: '-04',
        id: 79
    },
    {
        name: 'America/Halifax',
        displayName: 'GMT-04:00 哈里法克斯 AST',
        nameLocalized: '哈里法克斯',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 118
    },
    {
        name: 'America/Curacao',
        displayName: 'GMT-04:00 庫拉索 AST',
        nameLocalized: '庫拉索',
        abbreviationStandard: 'AST',
        id: 96
    },
    {
        name: 'America/Grenada',
        displayName: 'GMT-04:00 格瑞納達 AST',
        nameLocalized: '格瑞納達',
        abbreviationStandard: 'AST',
        id: 113
    },
    {
        name: 'America/Glace_Bay',
        displayName: 'GMT-04:00 格雷斯貝 AST',
        nameLocalized: '格雷斯貝',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 109
    },
    {
        name: 'America/Campo_Grande',
        displayName: 'GMT-04:00 格蘭場 -04/-03',
        nameLocalized: '格蘭場',
        abbreviationStandard: '-04/-03',
        id: 84
    },
    {
        name: 'America/Martinique',
        displayName: 'GMT-04:00 馬丁尼克 AST',
        nameLocalized: '馬丁尼克',
        abbreviationStandard: 'AST',
        id: 144
    },
    {
        name: 'America/Aruba',
        displayName: 'GMT-04:00 荷屬阿魯巴 AST',
        nameLocalized: '荷屬阿魯巴',
        abbreviationStandard: 'AST',
        id: 70
    },
    {
        name: 'America/St_Vincent',
        displayName: 'GMT-04:00 聖文森 AST',
        nameLocalized: '聖文森',
        abbreviationStandard: 'AST',
        id: 188
    },
    {
        name: 'America/Santiago',
        displayName: 'GMT-04:00 聖地牙哥 -04/-03',
        nameLocalized: '聖地牙哥',
        abbreviationStandard: '-04/-03',
        abbreviationDaylight: '-04/-03',
        id: 179,
        enabled: true
    },
    {
        name: 'America/Santo_Domingo',
        displayName: 'GMT-04:00 聖多明哥 AST',
        nameLocalized: '聖多明哥',
        abbreviationStandard: 'AST',
        id: 180
    },
    {
        name: 'America/St_Thomas',
        displayName: 'GMT-04:00 聖托馬斯 AST',
        nameLocalized: '聖托馬斯',
        abbreviationStandard: 'AST',
        id: 187
    },
    {
        name: 'America/St_Kitts',
        displayName: 'GMT-04:00 聖基茨 AST',
        nameLocalized: '聖基茨',
        abbreviationStandard: 'AST',
        id: 185
    },
    {
        name: 'America/St_Lucia',
        displayName: 'GMT-04:00 聖露西亞 AST',
        nameLocalized: '聖露西亞',
        abbreviationStandard: 'AST',
        id: 186
    },
    {
        name: 'America/Manaus',
        displayName: 'GMT-04:00 瑪瑙斯 -04',
        nameLocalized: '瑪瑙斯',
        abbreviationStandard: '-04',
        id: 143,
        enabled: true
    },
    {
        name: 'America/Porto_Velho',
        displayName: 'GMT-04:00 維留港 -04',
        nameLocalized: '維留港',
        abbreviationStandard: '-04',
        id: 170
    },
    {
        name: 'America/Moncton',
        displayName: 'GMT-04:00 蒙克頓 AST',
        nameLocalized: '蒙克頓',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 151
    },
    {
        name: 'America/Montserrat',
        displayName: 'GMT-04:00 蒙哲臘 AST',
        nameLocalized: '蒙哲臘',
        abbreviationStandard: 'AST',
        id: 155
    },
    {
        name: 'America/Guyana',
        displayName: 'GMT-04:00 蓋亞那 -04',
        nameLocalized: '蓋亞那',
        abbreviationStandard: '-04',
        id: 117
    },
    {
        name: 'America/Goose_Bay',
        displayName: 'GMT-04:00 鵝灣 AST',
        nameLocalized: '鵝灣',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 111,
        enabled: true
    },
    {
        name: 'Chile/Continental',
        displayName: 'GMT-04:00 Continental -04/-03',
        nameLocalized: 'Continental',
        abbreviationStandard: '-04/-03',
        abbreviationDaylight: '-04/-03',
        id: 346
    },
    {
        name: 'Etc/GMT-4',
        displayName: 'GMT-04:00 GMT-4 -04',
        nameLocalized: 'GMT-4',
        abbreviationStandard: '-04',
        id: 378
    },
    {
        name: 'Etc/GMT+4',
        displayName: 'GMT-04:00 GMT+4 -04',
        nameLocalized: 'GMT+4',
        abbreviationStandard: '-04',
        id: 363
    },
    {
        name: 'America/Virgin',
        displayName: 'GMT-04:00 Virgin AST',
        nameLocalized: 'Virgin',
        abbreviationStandard: 'AST',
        id: 197
    },
    {
        name: 'America/Grand_Turk',
        displayName: 'GMT-05:00 大特克島 EST',
        nameLocalized: '大特克島',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 112
    },
    {
        name: 'America/Port-au-Prince',
        displayName: 'GMT-05:00 太子港 EST',
        nameLocalized: '太子港',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 167
    },
    {
        name: 'America/Panama',
        displayName: 'GMT-05:00 巴拿馬 EST',
        nameLocalized: '巴拿馬',
        abbreviationStandard: 'EST',
        id: 163
    },
    {
        name: 'America/Jamaica',
        displayName: 'GMT-05:00 牙買加 EST',
        nameLocalized: '牙買加',
        abbreviationStandard: 'EST',
        id: 131
    },
    {
        name: 'America/Guayaquil',
        displayName: 'GMT-05:00 瓜亞基爾 -05/-04',
        nameLocalized: '瓜亞基爾',
        abbreviationStandard: '-05/-04',
        id: 116
    },
    {
        name: 'America/Iqaluit',
        displayName: 'GMT-05:00 伊魁特 EST',
        nameLocalized: '伊魁特',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 130
    },
    {
        name: 'America/Indiana/Petersburg',
        displayName: 'GMT-05:00 印第安那州彼得堡 EST',
        nameLocalized: '印第安那州彼得堡',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 124
    },
    {
        name: 'America/Indiana/Winamac',
        displayName: 'GMT-05:00 印第安那州威納馬克 EST',
        nameLocalized: '印第安那州威納馬克',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 127
    },
    {
        name: 'America/Indiana/Marengo',
        displayName: 'GMT-05:00 印第安那州馬倫哥 EST',
        nameLocalized: '印第安那州馬倫哥',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 123
    },
    {
        name: 'America/Indiana/Vincennes',
        displayName: 'GMT-05:00 印第安那州溫森斯 EST',
        nameLocalized: '印第安那州溫森斯',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 126
    },
    {
        name: 'America/Indiana/Vevay',
        displayName: 'GMT-05:00 印第安那州維威 EST',
        nameLocalized: '印第安那州維威',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 125
    },
    {
        name: 'America/Indianapolis',
        displayName: 'GMT-05:00 印第安那波里斯 EST',
        nameLocalized: '印第安那波里斯',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 128
    },
    {
        name: 'America/Toronto',
        displayName: 'GMT-05:00 多倫多 EST',
        nameLocalized: '多倫多',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 194
    },
    {
        name: 'America/Eirunepe',
        displayName: 'GMT-05:00 艾魯內佩 -05',
        nameLocalized: '艾魯內佩',
        abbreviationStandard: '-05',
        id: 104
    },
    {
        name: 'America/Lima',
        displayName: 'GMT-05:00 利馬 -05/-04',
        nameLocalized: '利馬',
        abbreviationStandard: '-05/-04',
        id: 138
    },
    {
        name: 'America/Cancun',
        displayName: 'GMT-05:00 坎昆 EST',
        nameLocalized: '坎昆',
        abbreviationStandard: 'EST',
        id: 85
    },
    {
        name: 'America/Rio_Branco',
        displayName: 'GMT-05:00 里約布蘭 -05',
        nameLocalized: '里約布蘭',
        abbreviationStandard: '-05',
        id: 177
    },
    {
        name: 'America/Detroit',
        displayName: 'GMT-05:00 底特律 EST',
        nameLocalized: '底特律',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 101
    },
    {
        name: 'America/Bogota',
        displayName: 'GMT-05:00 波哥大 -05/-04',
        nameLocalized: '波哥大',
        abbreviationStandard: '-05/-04',
        id: 80,
        enabled: true
    },
    {
        name: 'America/Kentucky/Monticello',
        displayName: 'GMT-05:00 肯塔基州蒙地卻羅 EST',
        nameLocalized: '肯塔基州蒙地卻羅',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 135
    },
    {
        name: 'America/Coral_Harbour',
        displayName: 'GMT-05:00 阿蒂科肯 EST',
        nameLocalized: '阿蒂科肯',
        abbreviationStandard: 'EST',
        id: 92
    },
    {
        name: 'America/Havana',
        displayName: 'GMT-05:00 哈瓦那 CST',
        nameLocalized: '哈瓦那',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 119
    },
    {
        name: 'America/Nassau',
        displayName: 'GMT-05:00 拿索 EST',
        nameLocalized: '拿索',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 156
    },
    {
        name: 'America/New_York',
        displayName: 'GMT-05:00 紐約 EST',
        nameLocalized: '紐約',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 157,
        enabled: true
    },
    {
        name: 'America/Cayman',
        displayName: 'GMT-05:00 開曼群島 EST',
        nameLocalized: '開曼群島',
        abbreviationStandard: 'EST',
        id: 89
    },
    {
        name: 'America/Louisville',
        displayName: 'GMT-05:00 路易斯維爾 EST',
        nameLocalized: '路易斯維爾',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 140
    },
    {
        name: 'Brazil/Acre',
        displayName: 'GMT-05:00 Acre -05',
        nameLocalized: 'Acre',
        abbreviationStandard: '-05',
        id: 332
    },
    {
        name: 'America/Atikokan',
        displayName: 'GMT-05:00 Atikokan EST',
        nameLocalized: 'Atikokan',
        abbreviationStandard: 'EST',
        id: 72
    },
    {
        name: 'US/East-Indiana',
        displayName: 'GMT-05:00 East-Indiana EST',
        nameLocalized: 'East-Indiana',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 539
    },
    {
        name: 'US/Eastern',
        displayName: 'GMT-05:00 Eastern EST',
        nameLocalized: 'Eastern',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 540
    },
    {
        name: 'EST',
        displayName: 'GMT-05:00 EST EST',
        nameLocalized: 'EST',
        abbreviationStandard: 'EST',
        id: 353
    },
    {
        name: 'EST5EDT',
        displayName: 'GMT-05:00 EST5EDT EST',
        nameLocalized: 'EST5EDT',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 354
    },
    {
        name: 'America/Fort_Wayne',
        displayName: 'GMT-05:00 Fort Wayne EST',
        nameLocalized: 'Fort Wayne',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 107
    },
    {
        name: 'Etc/GMT-5',
        displayName: 'GMT-05:00 GMT-5 -05',
        nameLocalized: 'GMT-5',
        abbreviationStandard: '-05',
        id: 379
    },
    {
        name: 'Etc/GMT+5',
        displayName: 'GMT-05:00 GMT+5 -05',
        nameLocalized: 'GMT+5',
        abbreviationStandard: '-05',
        id: 364
    },
    {
        name: 'America/Indiana/Indianapolis',
        displayName: 'GMT-05:00 Indianapolis EST',
        nameLocalized: 'Indianapolis',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 121
    },
    {
        name: 'America/Kentucky/Louisville',
        displayName: 'GMT-05:00 Louisville EST',
        nameLocalized: 'Louisville',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 134
    },
    {
        name: 'America/Montreal',
        displayName: 'GMT-05:00 Montreal EST',
        nameLocalized: 'Montreal',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 154
    },
    {
        name: 'America/Nipigon',
        displayName: 'GMT-05:00 Nipigon EST',
        nameLocalized: 'Nipigon',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 158
    },
    {
        name: 'America/Pangnirtung',
        displayName: 'GMT-05:00 Pangnirtung EST',
        nameLocalized: 'Pangnirtung',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 164
    },
    {
        name: 'America/Porto_Acre',
        displayName: 'GMT-05:00 Porto Acre -05',
        nameLocalized: 'Porto Acre',
        abbreviationStandard: '-05',
        id: 169
    },
    {
        name: 'America/Thunder_Bay',
        displayName: 'GMT-05:00 Thunder Bay EST',
        nameLocalized: 'Thunder Bay',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 192
    },
    {
        name: 'Pacific/Galapagos',
        displayName: 'GMT-06:00 加拉巴哥群島 -06/-05',
        nameLocalized: '加拉巴哥群島',
        abbreviationStandard: '-06/-05',
        id: 494
    },
    {
        name: 'America/North_Dakota/Center',
        displayName: 'GMT-06:00 北達科他州中心 CST',
        nameLocalized: '北達科他州中心',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 161
    },
    {
        name: 'America/North_Dakota/New_Salem',
        displayName: 'GMT-06:00 北達科他州紐沙倫 CST',
        nameLocalized: '北達科他州紐沙倫',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 162
    },
    {
        name: 'America/Guatemala',
        displayName: 'GMT-06:00 瓜地馬拉 CST',
        nameLocalized: '瓜地馬拉',
        abbreviationStandard: 'CST',
        id: 115,
        enabled: true
    },
    {
        name: 'America/Indiana/Knox',
        displayName: 'GMT-06:00 印第安那州諾克斯 CST',
        nameLocalized: '印第安那州諾克斯',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 122
    },
    {
        name: 'America/Belize',
        displayName: 'GMT-06:00 貝里斯 CST',
        nameLocalized: '貝里斯',
        abbreviationStandard: 'CST',
        id: 77
    },
    {
        name: 'America/Regina',
        displayName: 'GMT-06:00 里賈納 CST',
        nameLocalized: '里賈納',
        abbreviationStandard: 'CST',
        id: 175
    },
    {
        name: 'America/Chihuahua',
        displayName: 'GMT-06:00 奇華華 CST',
        nameLocalized: '奇華華',
        abbreviationStandard: 'CST',
        id: 91,
        enabled: true
    },
    {
        name: 'America/Chicago',
        displayName: 'GMT-06:00 芝加哥 CST',
        nameLocalized: '芝加哥',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 90,
        enabled: true
    },
    {
        name: 'America/Menominee',
        displayName: 'GMT-06:00 美諾米尼 CST',
        nameLocalized: '美諾米尼',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 147
    },
    {
        name: 'America/Costa_Rica',
        displayName: 'GMT-06:00 哥斯大黎加 CST',
        nameLocalized: '哥斯大黎加',
        abbreviationStandard: 'CST',
        id: 94
    },
    {
        name: 'America/Managua',
        displayName: 'GMT-06:00 馬拿瓜 CST',
        nameLocalized: '馬拿瓜',
        abbreviationStandard: 'CST',
        id: 142
    },
    {
        name: 'America/Merida',
        displayName: 'GMT-06:00 梅里達 CST',
        nameLocalized: '梅里達',
        abbreviationStandard: 'CST',
        id: 148
    },
    {
        name: 'Pacific/Easter',
        displayName: 'GMT-06:00 復活島 -06/-05',
        nameLocalized: '復活島',
        abbreviationStandard: '-06/-05',
        abbreviationDaylight: '-06/-05',
        id: 488
    },
    {
        name: 'America/Swift_Current',
        displayName: 'GMT-06:00 斯威夫特卡倫特 CST',
        nameLocalized: '斯威夫特卡倫特',
        abbreviationStandard: 'CST',
        id: 189
    },
    {
        name: 'America/Winnipeg',
        displayName: 'GMT-06:00 溫尼伯 CST',
        nameLocalized: '溫尼伯',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 199
    },
    {
        name: 'America/Monterrey',
        displayName: 'GMT-06:00 蒙特瑞 CST',
        nameLocalized: '蒙特瑞',
        abbreviationStandard: 'CST',
        id: 152
    },
    {
        name: 'America/Tegucigalpa',
        displayName: 'GMT-06:00 德古斯加巴 CST',
        nameLocalized: '德古斯加巴',
        abbreviationStandard: 'CST',
        id: 190
    },
    {
        name: 'America/Mexico_City',
        displayName: 'GMT-06:00 墨西哥市 CST',
        nameLocalized: '墨西哥市',
        abbreviationStandard: 'CST',
        id: 149,
        enabled: true
    },
    {
        name: 'America/El_Salvador',
        displayName: 'GMT-06:00 薩爾瓦多 CST',
        nameLocalized: '薩爾瓦多',
        abbreviationStandard: 'CST',
        id: 105
    },
    {
        name: 'America/Resolute',
        displayName: 'GMT-06:00 羅斯魯特 CST',
        nameLocalized: '羅斯魯特',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 176
    },
    {
        name: 'America/Rankin_Inlet',
        displayName: 'GMT-06:00 蘭今灣 CST',
        nameLocalized: '蘭今灣',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 173
    },
    {
        name: 'Canada/Central',
        displayName: 'GMT-06:00 Central CST',
        nameLocalized: 'Central',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 337
    },
    {
        name: 'CST6CDT',
        displayName: 'GMT-06:00 CST6CDT CST',
        nameLocalized: 'CST6CDT',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 348
    },
    {
        name: 'Mexico/General',
        displayName: 'GMT-06:00 General CST',
        nameLocalized: 'General',
        abbreviationStandard: 'CST',
        id: 479
    },
    {
        name: 'Etc/GMT-6',
        displayName: 'GMT-06:00 GMT-6 -06',
        nameLocalized: 'GMT-6',
        abbreviationStandard: '-06',
        id: 380
    },
    {
        name: 'Etc/GMT+6',
        displayName: 'GMT-06:00 GMT+6 -06',
        nameLocalized: 'GMT+6',
        abbreviationStandard: '-06',
        id: 365
    },
    {
        name: 'US/Indiana-Starke',
        displayName: 'GMT-06:00 Indiana-Starke CST',
        nameLocalized: 'Indiana-Starke',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 542
    },
    {
        name: 'America/Knox_IN',
        displayName: 'GMT-06:00 Knox IN CST',
        nameLocalized: 'Knox IN',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 136
    },
    {
        name: 'America/Rainy_River',
        displayName: 'GMT-06:00 Rainy River CST',
        nameLocalized: 'Rainy River',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 172
    },
    {
        name: 'America/Denver',
        displayName: 'GMT-07:00 丹佛 MST',
        nameLocalized: '丹佛',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 100,
        enabled: true
    },
    {
        name: 'America/Inuvik',
        displayName: 'GMT-07:00 伊奴維克 MST',
        nameLocalized: '伊奴維克',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 129
    },
    {
        name: 'America/Edmonton',
        displayName: 'GMT-07:00 艾德蒙吞 MST',
        nameLocalized: '艾德蒙吞',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 103
    },
    {
        name: 'America/Boise',
        displayName: 'GMT-07:00 波夕 MST',
        nameLocalized: '波夕',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 81
    },
    {
        name: 'America/Hermosillo',
        displayName: 'GMT-07:00 埃莫西約 MST',
        nameLocalized: '埃莫西約',
        abbreviationStandard: 'MST',
        id: 120
    },
    {
        name: 'America/Mazatlan',
        displayName: 'GMT-07:00 馬薩特蘭 MST',
        nameLocalized: '馬薩特蘭',
        abbreviationStandard: 'MST',
        id: 145
    },
    {
        name: 'America/Dawson',
        displayName: 'GMT-07:00 道森 MST',
        nameLocalized: '道森',
        abbreviationStandard: 'MST',
        id: 98
    },
    {
        name: 'America/Dawson_Creek',
        displayName: 'GMT-07:00 道森克里克 MST',
        nameLocalized: '道森克里克',
        abbreviationStandard: 'MST',
        id: 99
    },
    {
        name: 'America/Phoenix',
        displayName: 'GMT-07:00 鳳凰城 MST',
        nameLocalized: '鳳凰城',
        abbreviationStandard: 'MST',
        id: 166,
        enabled: true
    },
    {
        name: 'America/Cambridge_Bay',
        displayName: 'GMT-07:00 劍橋灣 MST',
        nameLocalized: '劍橋灣',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 83
    },
    {
        name: 'America/Whitehorse',
        displayName: 'GMT-07:00 懷特霍斯 MST',
        nameLocalized: '懷特霍斯',
        abbreviationStandard: 'MST',
        id: 198
    },
    {
        name: 'Mexico/BajaSur',
        displayName: 'GMT-07:00 BajaSur MST',
        nameLocalized: 'BajaSur',
        abbreviationStandard: 'MST',
        id: 478
    },
    {
        name: 'Etc/GMT-7',
        displayName: 'GMT-07:00 GMT-7 -07',
        nameLocalized: 'GMT-7',
        abbreviationStandard: '-07',
        id: 381
    },
    {
        name: 'Etc/GMT+7',
        displayName: 'GMT-07:00 GMT+7 -07',
        nameLocalized: 'GMT+7',
        abbreviationStandard: '-07',
        id: 366
    },
    {
        name: 'Canada/Mountain',
        displayName: 'GMT-07:00 Mountain MST',
        nameLocalized: 'Mountain',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 340
    },
    {
        name: 'MST',
        displayName: 'GMT-07:00 MST MST',
        nameLocalized: 'MST',
        abbreviationStandard: 'MST',
        id: 480
    },
    {
        name: 'MST7MDT',
        displayName: 'GMT-07:00 MST7MDT MST',
        nameLocalized: 'MST7MDT',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 481
    },
    {
        name: 'America/Yellowknife',
        displayName: 'GMT-07:00 Yellowknife MST',
        nameLocalized: 'Yellowknife',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 201
    },
    {
        name: 'Canada/Yukon',
        displayName: 'GMT-07:00 Yukon MST',
        nameLocalized: 'Yukon',
        abbreviationStandard: 'MST',
        id: 344
    },
    {
        name: 'Pacific/Pitcairn',
        displayName: 'GMT-08:00 皮特肯群島 -08',
        nameLocalized: '皮特肯群島',
        abbreviationStandard: '-08',
        id: 512
    },
    {
        name: 'America/Los_Angeles',
        displayName: 'GMT-08:00 洛杉磯 PST',
        nameLocalized: '洛杉磯',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 139,
        enabled: true
    },
    {
        name: 'America/Tijuana',
        displayName: 'GMT-08:00 提華納 PST',
        nameLocalized: '提華納',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 193,
        enabled: true
    },
    {
        name: 'America/Vancouver',
        displayName: 'GMT-08:00 溫哥華 PST',
        nameLocalized: '溫哥華',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 196
    },
    {
        name: 'America/Ensenada',
        displayName: 'GMT-08:00 Ensenada PST',
        nameLocalized: 'Ensenada',
        abbreviationStandard: 'PST',
        id: 106
    },
    {
        name: 'Etc/GMT-8',
        displayName: 'GMT-08:00 GMT-8 -08',
        nameLocalized: 'GMT-8',
        abbreviationStandard: '-08',
        id: 382
    },
    {
        name: 'Etc/GMT+8',
        displayName: 'GMT-08:00 GMT+8 -08',
        nameLocalized: 'GMT+8',
        abbreviationStandard: '-08',
        id: 367
    },
    {
        name: 'Canada/Pacific',
        displayName: 'GMT-08:00 Pacific PST',
        nameLocalized: 'Pacific',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 342
    },
    {
        name: 'US/Pacific',
        displayName: 'GMT-08:00 Pacific PST',
        nameLocalized: 'Pacific',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 545
    },
    {
        name: 'PST8PDT',
        displayName: 'GMT-08:00 PST8PDT PST',
        nameLocalized: 'PST8PDT',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 528
    },
    {
        name: 'Pacific/Marquesas',
        displayName: 'GMT-09:30 馬可薩斯島 -0930',
        nameLocalized: '馬可薩斯島',
        abbreviationStandard: '-0930',
        id: 504
    },
    {
        name: 'Pacific/Gambier',
        displayName: 'GMT-09:00 甘比爾群島 -09',
        nameLocalized: '甘比爾群島',
        abbreviationStandard: '-09',
        id: 495
    },
    {
        name: 'America/Anchorage',
        displayName: 'GMT-09:00 安克拉治 AKST',
        nameLocalized: '安克拉治',
        abbreviationStandard: 'AKST',
        abbreviationDaylight: 'AKDT',
        id: 55
    },
    {
        name: 'America/Juneau',
        displayName: 'GMT-09:00 朱諾 AKST',
        nameLocalized: '朱諾',
        abbreviationStandard: 'AKST',
        abbreviationDaylight: 'AKDT',
        id: 133,
        enabled: true
    },
    {
        name: 'America/Yakutat',
        displayName: 'GMT-09:00 雅庫塔 AKST',
        nameLocalized: '雅庫塔',
        abbreviationStandard: 'AKST',
        abbreviationDaylight: 'AKDT',
        id: 200
    },
    {
        name: 'America/Nome',
        displayName: 'GMT-09:00 諾姆 AKST',
        nameLocalized: '諾姆',
        abbreviationStandard: 'AKST',
        abbreviationDaylight: 'AKDT',
        id: 159
    },
    {
        name: 'US/Alaska',
        displayName: 'GMT-09:00 Alaska AKST',
        nameLocalized: 'Alaska',
        abbreviationStandard: 'AKST',
        abbreviationDaylight: 'AKDT',
        id: 535
    },
    {
        name: 'Etc/GMT-9',
        displayName: 'GMT-09:00 GMT-9 -09',
        nameLocalized: 'GMT-9',
        abbreviationStandard: '-09',
        id: 383
    },
    {
        name: 'Etc/GMT+9',
        displayName: 'GMT-09:00 GMT+9 -09',
        nameLocalized: 'GMT+9',
        abbreviationStandard: '-09',
        id: 368
    },
    {
        name: 'Pacific/Tahiti',
        displayName: 'GMT-10:00 大溪地 -10',
        nameLocalized: '大溪地',
        abbreviationStandard: '-10',
        id: 518
    },
    {
        name: 'America/Adak',
        displayName: 'GMT-10:00 艾達克 HST',
        nameLocalized: '艾達克',
        abbreviationStandard: 'HST',
        abbreviationDaylight: 'HDT',
        id: 54
    },
    {
        name: 'Pacific/Rarotonga',
        displayName: 'GMT-10:00 拉羅湯加 -10/-0930',
        nameLocalized: '拉羅湯加',
        abbreviationStandard: '-10/-0930',
        id: 515
    },
    {
        name: 'Pacific/Honolulu',
        displayName: 'GMT-10:00 檀香山 HST',
        nameLocalized: '檀香山',
        abbreviationStandard: 'HST',
        id: 498,
        enabled: true
    },
    {
        name: 'Etc/GMT-10',
        displayName: 'GMT-10:00 GMT-10 -10',
        nameLocalized: 'GMT-10',
        abbreviationStandard: '-10',
        id: 371
    },
    {
        name: 'Etc/GMT+10',
        displayName: 'GMT-10:00 GMT+10 -10',
        nameLocalized: 'GMT+10',
        abbreviationStandard: '-10',
        id: 358
    },
    {
        name: 'US/Hawaii',
        displayName: 'GMT-10:00 Hawaii HST',
        nameLocalized: 'Hawaii',
        abbreviationStandard: 'HST',
        id: 541
    },
    {
        name: 'HST',
        displayName: 'GMT-10:00 HST HST',
        nameLocalized: 'HST',
        abbreviationStandard: 'HST',
        id: 457
    },
    {
        name: 'Pacific/Johnston',
        displayName: 'GMT-10:00 Johnston HST',
        nameLocalized: 'Johnston',
        abbreviationStandard: 'HST',
        id: 499
    },
    {
        name: 'Pacific/Midway',
        displayName: 'GMT-11:00 中途島 SST',
        nameLocalized: '中途島',
        abbreviationStandard: 'SST',
        id: 505,
        enabled: true
    },
    {
        name: 'Pacific/Pago_Pago',
        displayName: 'GMT-11:00 巴哥巴哥 SST',
        nameLocalized: '巴哥巴哥',
        abbreviationStandard: 'SST',
        id: 510
    },
    {
        name: 'Pacific/Niue',
        displayName: 'GMT-11:00 紐埃島 -11',
        nameLocalized: '紐埃島',
        abbreviationStandard: '-11',
        id: 507
    },
    {
        name: 'Etc/GMT-11',
        displayName: 'GMT-11:00 GMT-11 -11',
        nameLocalized: 'GMT-11',
        abbreviationStandard: '-11',
        id: 372
    },
    {
        name: 'Etc/GMT+11',
        displayName: 'GMT-11:00 GMT+11 -11',
        nameLocalized: 'GMT+11',
        abbreviationStandard: '-11',
        id: 359
    },
    {
        name: 'Pacific/Samoa',
        displayName: 'GMT-11:00 Samoa SST',
        nameLocalized: 'Samoa',
        abbreviationStandard: 'SST',
        id: 517
    },
    {
        name: 'US/Samoa',
        displayName: 'GMT-11:00 Samoa SST',
        nameLocalized: 'Samoa',
        abbreviationStandard: 'SST',
        id: 547
    },
    {
        name: 'Etc/GMT-12',
        displayName: 'GMT-12:00 GMT-12 -12',
        nameLocalized: 'GMT-12',
        abbreviationStandard: '-12',
        id: 373
    },
    {
        name: 'Etc/GMT+12',
        displayName: 'GMT-12:00 GMT+12 -12',
        nameLocalized: 'GMT+12',
        abbreviationStandard: '-12',
        id: 360
    },
];

const weekData: WeekData = {
    firstDay: 0,
    weekendStart: 6,
    weekendEnd: 0
};

const weekDayNames: WeekDayNameData = {
    days: {
        abbreviated: {
            sun: '週日',
            mon: '週一',
            tue: '週二',
            wed: '週三',
            thu: '週四',
            fri: '週五',
            sat: '週六',
        },
        narrow: {
            sun: '日',
            mon: '一',
            tue: '二',
            wed: '三',
            thu: '四',
            fri: '五',
            sat: '六',
        },
        short: {
            sun: '日',
            mon: '一',
            tue: '二',
            wed: '三',
            thu: '四',
            fri: '五',
            sat: '六',
        },
        wide: {
            sun: '星期日',
            mon: '星期一',
            tue: '星期二',
            wed: '星期三',
            thu: '星期四',
            fri: '星期五',
            sat: '星期六',
        },
    },
    standAlone: {
        abbreviated: {
            sun: '週日',
            mon: '週一',
            tue: '週二',
            wed: '週三',
            thu: '週四',
            fri: '週五',
            sat: '週六',
        },
        narrow: {
            sun: '日',
            mon: '一',
            tue: '二',
            wed: '三',
            thu: '四',
            fri: '五',
            sat: '六',
        },
        short: {
            sun: '日',
            mon: '一',
            tue: '二',
            wed: '三',
            thu: '四',
            fri: '五',
            sat: '六',
        },
        wide: {
            sun: '星期日',
            mon: '星期一',
            tue: '星期二',
            wed: '星期三',
            thu: '星期四',
            fri: '星期五',
            sat: '星期六',
        },
    },
};

const data: LocaleData = {
    languages,
    numbers,
    timezones,
    weekData,
    weekDayNames
};

export default data;
